import {Form, Formik, FormikValues} from 'formik'
import {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {useDispatch} from 'react-redux'
import * as contractRedux from '../redux/ContractRedux'
import {useBetween} from 'use-between'
import {StepperComponent} from '../../../_metronic/assets/ts/components'
import {KTSVG} from '../../../_metronic/helpers'
import {Loading} from '../../utils/loadingR/Loading'
import {HorizontalMenuForm, menuHorizontal} from '../../utils/horizontalMenuForm/HorizontalMenuForm'
import {BTCreateContract2} from './BTContract/BTCreateContract2'
import {BTCreateContract3} from './BTContract/BTCreateContract3'
import {BTCreateContract4} from './BTContract/BTCreateContract4'
import {BTCreateContract6} from './BTContract/BTCreateContract6'
import StepContract1 from './form/StepContract1'
import {StepContract2, contStep2} from './form/StepContract2'
import {contStep3, StepContract3} from './form/StepContract3'
import {createContractSchemas, ICreateContract, initsContract as inits} from './ICreateContract'
import {contStep4, StepContract4} from './form/StepContract4'
import {StepContract5} from './form/StepContract5'
import {contStep6, StepContract6} from './form/StepContract6'
import {callSP, callSPUp} from '../../../setup/axios/AxiosCallSP'
import {useLocation, useNavigate} from 'react-router-dom'
import {
  getLStorage,
  groupBy,
  groupByMultiple,
  removeLStorage,
  removeSStorage,
  setLStorage,
  setSStorage,
} from '../../../global.d'
import {warn, error, info, success} from '../../utils/customToasd'
import {
  validateIngredientsFrequency,
  saveContract,
  mapCatDietetica,
  getPlateTypesLevels,
  getFrequencyTypeText,
  getTemplateTypeText,
  validateStep1,
  mapDaysStr,
  validateStep6,
  validateStep4,
} from './form/step.service'
import {unique, mapBlockedDays} from './createContractService'
import {StepLoadContract2} from './stepLoadContract/StepLoadContract2'
import {StepLoadContract6} from './stepLoadContract/StepLoadContract6'
import {StepLoadContract4} from './stepLoadContract/StepLoadContract4'

import {getSStorage} from 'global.d'

const CreateContract: FC<any> = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const {contractSchemas, setContractSchemas, setDataRow2, dataRow2} = useBetween(BTCreateContract2)
  const {setDataRow3, dataRow3, dataModelo3} = useBetween(BTCreateContract3)
  const {setDataRow4, dataRow4} = useBetween(BTCreateContract4)
  const {setDataRow6, dataRow6} = useBetween(BTCreateContract6)
  const [initValues, setInitValues] = useState<ICreateContract>(inits)
  const [isSubmitButton, setSubmitButton] = useState(false)
  const [reloadGrid, setReloadGrid] = useState(false)
  const [reload5, setReload5] = useState(false)
  const [reload3, setReload3] = useState(false)
  const [reload4, setReload4] = useState(false)
  const [editContract, setEditContract] = useState(false)
  const [reloadStep2, setReloadStep2] = useState(false)
  const [menus] = useState<menuHorizontal[]>([
    {
      text: 'Contrato',
      isCurrent: true,
    },
    {
      text: 'Estructura',
    },
    {
      text: 'Estructura Fija',
    },
    {
      text: 'Receta Fija',
    },
    {
      text: 'Frecuencia Ingredientes',
    },
    {
      text: 'Reglas',
    },
  ])

  const [load, setLoad] = useState(false)
  const [isReady, setIsReady] = useState<boolean>(false)
  const [isHomologada, setIsHomologada] = useState<any>(false)
  const [bloqueado, setBloqueado] = useState<any>(false)
  const [sitios, setSitios] = useState<any[]>([])
  const [regimens, setRegimens] = useState<any[]>([])

  const [intolerancias, setIntolerancias] = useState<any[]>([])
  const [estructuraFijas, setEstructuraFijas] = useState<any[]>([])
  const [recetaEstructuraFijas, setRecetaEstructuraFijas] = useState<any[]>([])
  // Guardar todas las frecuencias sin filtrar para validaciones
  const [todasLasFrecuenciasSinFiltrar, setTodasLasFrecuenciasSinFiltrar] = useState<any[]>([])
  // Guardar todas las recetas fijas sin filtrar
  const [todasLasRecetasFijasSinFiltrar, setTodasLasRecetasFijasSinFiltrar] = useState<any[]>([])
  // Guardar todas las estructuras fijas sin filtrar
  const [todasLasEstructurasFijasSinFiltrar, setTodasLasEstructurasFijasSinFiltrar] = useState<any[]>([])
  const [alergenos, setAlergenos] = useState<any[]>([])

  const [grupoEstructuras, setGrupoEstructuras] = useState<any[]>([])
  const [categoriaDietetica, setCategoriaDietetica] = useState<any[]>([])
  const [categoriaDieteticaRec, setCategoriaDieteticaRec] = useState<any[]>([])

  const [datosByContrato, setDatosByContrato] = useState<any[]>([])
  const [recetaFija, setRecetaFija] = useState<any[]>([])
  const [estructuraFija, setEstructuraFija] = useState<any[]>([])
  const [diasSemana, setDiasSemana] = useState<any[]>([])
  const [reglas, setReglas] = useState<any[]>([])
  const [hasContract, setHasContract] = useState<any>(null)
  const [contract, setContract] = useState<any>(null)
  const [datosContrato, setDatosContrato] = useState<any[]>([])
  const [dataEstructuraByContrato, setDataEstructuraByContrato] = useState<any[]>([])
  const [editDataStep1, setEditDataStep1] = useState<any>(null)
  const [tipoPlatos, setTipoPlatos] = useState<any[]>([])
  const [ingAdyacentes, setIngAdyacentes] = useState<any>([])
  const [usuariosSistios, setUsuariosSitios] = useState([])
  const [contractList, setContractList] = useState<any[]>([])

  let _state: any = {}

  async function name2() {
    const state: any = location.state
    if (state?.params) {
      const contract = {
        ...state?.params,
        id: state?.contrato,
      }
      _state = contract

      if (contract?.plantilla > 0 || contract?.minuta > 0) {
        //setIsHomologadaInput(true)
      }
    }
  }
  name2()
  useEffect(() => {
    setLoad(true)
    setLStorage('dataRow3', '')
    //removeSStorage('contractId')
    const state: any = location.state
    if (state?.params) {
      const contract = {
        ...state?.params,
        id: state?.contrato,
      }
      _state = contract
      const msg: string = ``
      if (contract?.plantilla > 0 || contract?.minuta > 0)
        info('Solo se pueden editar datos que no afecten frecuencia')
      setHasContract(contract)
      getData(contract, true)
    } else {
      // CRÍTICO: Limpiar localStorage al iniciar un nuevo contrato (no edición)
      // Esto evita que se procesen datos residuales de sesiones anteriores
      localStorage.removeItem('estructurasFijasSeleccionadas')
      localStorage.removeItem('estructurasFijasMultiples')
      localStorage.removeItem('estructurasSeleccionadas')
      localStorage.removeItem('estructurasSeleccionadasConNombres') // CRÍTICO: También limpiar los nombres
      localStorage.removeItem('estructurasMultiples')
      localStorage.removeItem('contratoOrigenSeleccionado')
      localStorage.removeItem('contratoBase')
      localStorage.removeItem('templateHomologada2')
      localStorage.removeItem('homologada2')
      getData()
      setInitValues(inits)
    }

    return () => {
      setHasContract(null)
      clearDataGrid()
    }
  }, [])

  const assignObjectPaths = (obj: any, stack?: any) => {
    Object.keys(obj).forEach((k) => {
      const node = obj[k]
      if (typeof node === 'object') {
        node.path = stack ? `${stack}.${k}` : k
        assignObjectPaths(node, node.path)
      }
    })
  }

  useEffect(() => {
    if (categoriaDietetica.length) {
      const recursive: any = mapCatDietetica(categoriaDietetica, 'codigobisnieto')
      assignObjectPaths(recursive)
      setCategoriaDieteticaRec(recursive)
    }
  }, [categoriaDietetica])

  // CRÍTICO: Filtrar recetas fijas cuando cambien las estructuras seleccionadas
  // IMPORTANTE: Usar SOLO las estructuras que el usuario seleccionó en el modal (localStorage)
  useEffect(() => {
    // NO filtrar en modo edición
    if (editContract) {
      return
    }
    
    // CRÍTICO: Solo procesar si hay un contrato origen seleccionado
    // Esto evita ejecutar el filtro al cargar la página sin seleccionar nada
    const contratoOrigenSeleccionado = localStorage.getItem('contratoOrigenSeleccionado')
    if (!contratoOrigenSeleccionado) {
      return
    }

    // Obtener todas las recetas fijas actuales (sin filtrar)
    const todasLasRecetas = todasLasRecetasFijasSinFiltrar.length > 0 ? todasLasRecetasFijasSinFiltrar : dataRow3
    if (!todasLasRecetas || todasLasRecetas.length === 0) {
      return
    }

    // CRÍTICO: Obtener NOMBRES de estructuras seleccionadas desde localStorage
    // El campo "nombre" de estructurasSeleccionadasConNombres debe coincidir con el campo "estructura" de las recetas
    const nombresEstructurasSeleccionadas = new Set<string>()

    try {
      // 1. Obtener nombres de estructuras del contrato origen
      const estructurasConNombresStr = localStorage.getItem('estructurasSeleccionadasConNombres')
      if (estructurasConNombresStr && estructurasConNombresStr !== '[]' && estructurasConNombresStr !== '') {
        const estructurasConNombres = JSON.parse(estructurasConNombresStr)
        if (Array.isArray(estructurasConNombres)) {
          estructurasConNombres.forEach((est: any) => {
            if (est.nombre) {
              nombresEstructurasSeleccionadas.add(est.nombre.toLowerCase().trim())
            }
          })
        }
      }

      // 2. Obtener nombres de estructuras múltiples seleccionadas
      const estructurasMultiplesStr = localStorage.getItem('estructurasMultiples')
      if (estructurasMultiplesStr && estructurasMultiplesStr !== '[]' && estructurasMultiplesStr !== '') {
        const estructurasMultiples = JSON.parse(estructurasMultiplesStr)
        if (Array.isArray(estructurasMultiples)) {
          estructurasMultiples.forEach((est: any) => {
            // El campo nombre viene de ess_nombre, nombre o estructura
            const nombre = (est.ess_nombre || est.nombre || est.estructura || '').toLowerCase().trim()
            if (nombre) {
              nombresEstructurasSeleccionadas.add(nombre)
            }
          })
        }
      }
    } catch (e) {
      // Error al leer estructuras seleccionadas
    }

    // Si no hay estructuras seleccionadas en localStorage, no filtrar
    if (nombresEstructurasSeleccionadas.size === 0) {
      return
    }

    // Filtrar recetas: el campo fatherStructure2 (que viene de "estructura") debe estar en los nombres seleccionados
    const recetasFiltradas = todasLasRecetas.filter((receta: any) => {
      // El campo fatherStructure2 viene del campo "estructura" del SP amd_getRecetaFijaByContrato
      const nombreEstructuraReceta = receta.fatherStructure2 ? receta.fatherStructure2.toLowerCase().trim() : ''

      // Comparar el campo "estructura" de la receta con los nombres seleccionados
      const estaSeleccionada = nombreEstructuraReceta && nombresEstructurasSeleccionadas.has(nombreEstructuraReceta)

      return estaSeleccionada
    })

    // Actualizar dataRow3 con las recetas filtradas
    setDataRow3(recetasFiltradas)
  }, [dataRow2, todasLasRecetasFijasSinFiltrar]) // Depender de dataRow2 para detectar cambios, pero usar localStorage para filtrar

  // CRÍTICO: Filtrar frecuencia de ingredientes cuando cambien las estructuras seleccionadas
  // IMPORTANTE: Usar SOLO las estructuras que el usuario seleccionó en el modal (localStorage)
  useEffect(() => {
    // NO filtrar en modo edición
    if (editContract) {
      return
    }
    
    // CRÍTICO: Solo procesar si hay un contrato origen seleccionado
    // Esto evita ejecutar el filtro al cargar la página sin seleccionar nada
    const contratoOrigenSeleccionado = localStorage.getItem('contratoOrigenSeleccionado')
    if (!contratoOrigenSeleccionado) {
      return
    }

    // Obtener todas las frecuencias sin filtrar (usar la copia guardada o dataRow4 como fallback)
    const todasLasFrecuencias = todasLasFrecuenciasSinFiltrar.length > 0 ? todasLasFrecuenciasSinFiltrar : dataRow4
    if (!todasLasFrecuencias || todasLasFrecuencias.length === 0) {
      return
    }

    // CRÍTICO: Obtener NOMBRES de estructuras seleccionadas desde localStorage
    // El campo "nombre" de estructurasSeleccionadasConNombres debe coincidir con el campo "estructura" de las frecuencias
    const nombresEstructurasSeleccionadas = new Set<string>()

    try {
      // 1. Obtener nombres de estructuras del contrato origen
      const estructurasConNombresStr = localStorage.getItem('estructurasSeleccionadasConNombres')
      if (estructurasConNombresStr && estructurasConNombresStr !== '[]' && estructurasConNombresStr !== '') {
        const estructurasConNombres = JSON.parse(estructurasConNombresStr)
        if (Array.isArray(estructurasConNombres)) {
          estructurasConNombres.forEach((est: any) => {
            if (est.nombre) {
              nombresEstructurasSeleccionadas.add(est.nombre.toLowerCase().trim())
            }
          })
        }
      }

      // 2. Obtener nombres de estructuras múltiples seleccionadas
      const estructurasMultiplesStr = localStorage.getItem('estructurasMultiples')
      if (estructurasMultiplesStr && estructurasMultiplesStr !== '[]' && estructurasMultiplesStr !== '') {
        const estructurasMultiples = JSON.parse(estructurasMultiplesStr)
        if (Array.isArray(estructurasMultiples)) {
          estructurasMultiples.forEach((est: any) => {
            // El campo nombre viene de ess_nombre, nombre o estructura
            const nombre = (est.ess_nombre || est.nombre || est.estructura || '').toLowerCase().trim()
            if (nombre) {
              nombresEstructurasSeleccionadas.add(nombre)
            }
          })
        }
      }
    } catch (e) {
      // Error al leer estructuras seleccionadas
    }

    // Si no hay estructuras seleccionadas en localStorage, no filtrar
    if (nombresEstructurasSeleccionadas.size === 0) {
      return
    }

    // Filtrar frecuencias: el campo fatherStructure3 (que viene de "estructura") debe estar en los nombres seleccionados
    const frecuenciasFiltradas = todasLasFrecuencias.filter((frecuencia: any) => {
      // El campo fatherStructure3 viene del campo "estructura" del SP amd_getDatosByContrato
      const nombreEstructuraFrecuencia = frecuencia.fatherStructure3 ? frecuencia.fatherStructure3.toLowerCase().trim() : ''

      // Comparar el campo "estructura" de la frecuencia con los nombres seleccionados
      const estaSeleccionada = nombreEstructuraFrecuencia && nombresEstructurasSeleccionadas.has(nombreEstructuraFrecuencia)

      return estaSeleccionada
    })

    // Actualizar dataRow4 con las frecuencias filtradas
    setDataRow4(frecuenciasFiltradas)
  }, [dataRow2, todasLasFrecuenciasSinFiltrar]) // Depender de dataRow2 para detectar cambios

  // CRÍTICO: Filtrar estructuras fijas cuando cambien las estructuras seleccionadas
  // Las estructuras fijas se filtran por las estructuras fijas seleccionadas en localStorage,
  // NO por las estructuras normales en dataRow2
  useEffect(() => {
    // NO filtrar en modo edición
    if (editContract) {
      return
    }
    
    // CRÍTICO: Solo procesar si hay un contrato origen seleccionado
    // Esto evita ejecutar el filtro al cargar la página sin seleccionar nada
    const contratoOrigenSeleccionado = localStorage.getItem('contratoOrigenSeleccionado')
    if (!contratoOrigenSeleccionado) {
      return
    }
    
    // Obtener todas las estructuras fijas sin filtrar
    const todasLasEstructurasFijas = todasLasEstructurasFijasSinFiltrar.length > 0 
      ? todasLasEstructurasFijasSinFiltrar 
      : dataRow6
    
    if (!todasLasEstructurasFijas || todasLasEstructurasFijas.length === 0) {
      return
    }

    // Leer estructuras fijas seleccionadas de localStorage
    let estructurasFijasSeleccionadas: any[] = []
    let estructurasFijasMultiples: any[] = []

    try {
      const estructurasFijasSeleccionadasStr = localStorage.getItem('estructurasFijasSeleccionadas')
      if (estructurasFijasSeleccionadasStr && estructurasFijasSeleccionadasStr !== '[]' && estructurasFijasSeleccionadasStr !== '') {
        estructurasFijasSeleccionadas = JSON.parse(estructurasFijasSeleccionadasStr)
        if (!Array.isArray(estructurasFijasSeleccionadas)) {
          estructurasFijasSeleccionadas = []
        }
      }
    } catch (e) {
      estructurasFijasSeleccionadas = []
    }

    try {
      const estructurasFijasMultiplesStr = localStorage.getItem('estructurasFijasMultiples')
      if (estructurasFijasMultiplesStr && estructurasFijasMultiplesStr !== '[]' && estructurasFijasMultiplesStr !== '') {
        estructurasFijasMultiples = JSON.parse(estructurasFijasMultiplesStr)
        if (!Array.isArray(estructurasFijasMultiples)) {
          estructurasFijasMultiples = []
        }
      }
    } catch (e) {
      estructurasFijasMultiples = []
    }

    const todasEstructurasFijasSeleccionadas = [...estructurasFijasSeleccionadas, ...estructurasFijasMultiples]

    if (todasEstructurasFijasSeleccionadas.length === 0) {
      // Si no hay estructuras fijas seleccionadas, mostrar todas
      return
    }

    // Crear un Set con las claves de las estructuras fijas seleccionadas
    const estructurasFijasSeleccionadasSet = new Set<string>()

    todasEstructurasFijasSeleccionadas.forEach((ef: any) => {
      // Crear múltiples claves posibles para asegurar coincidencia
      const idReceta = ef.id_receta || ef.idRecipe || ef.idReceta
      const idEstructura = ef.id_estructura || ef.idStructure || ef.id_estructura_contrato
      const contratoId = ef.contratoId || ef.contrato

      if (idReceta) {
        // CRÍTICO: Para estructuras fijas, la clave más importante es id_receta + contratoId
        // porque la misma receta puede estar en múltiples contratos
        if (contratoId) {
          estructurasFijasSeleccionadasSet.add(`${idReceta}-${contratoId}`)
        }
        
        // También agregar con id_estructura si está disponible
        if (idEstructura) {
          estructurasFijasSeleccionadasSet.add(`${idReceta}-${idEstructura}`)
          if (contratoId) {
            estructurasFijasSeleccionadasSet.add(`${idReceta}-${idEstructura}-${contratoId}`)
          }
        }
        
        // Agregar solo por id_receta como último fallback
        estructurasFijasSeleccionadasSet.add(`${idReceta}`)
      }
    })

    // Filtrar estructuras fijas que estén en el Set
    const estructurasFijasFiltradas = todasLasEstructurasFijas.filter((estructuraFija: any) => {
      const idReceta = estructuraFija.idRecipe || estructuraFija.id_receta
      const idEstructura = estructuraFija.idStructure || estructuraFija.id_estructura || estructuraFija.idFatherStructure
      const contratoId = estructuraFija.contrato

      // Verificar múltiples combinaciones de claves
      // PRIORIDAD: id_receta + contratoId (más específico)
      const key1 = contratoId ? `${idReceta}-${contratoId}` : null
      const key2 = idEstructura ? `${idReceta}-${idEstructura}` : null
      const key3 = (contratoId && idEstructura) ? `${idReceta}-${idEstructura}-${contratoId}` : null
      const key4 = idReceta ? `${idReceta}` : null

      const estaSeleccionada = (key1 && estructurasFijasSeleccionadasSet.has(key1)) ||
                               (key2 && estructurasFijasSeleccionadasSet.has(key2)) ||
                               (key3 && estructurasFijasSeleccionadasSet.has(key3)) ||
                               (key4 && estructurasFijasSeleccionadasSet.has(key4))

      return estaSeleccionada
    })

    // Actualizar dataRow6 con las estructuras fijas filtradas
    setDataRow6(estructurasFijasFiltradas)
  }, [todasLasEstructurasFijasSinFiltrar.length]) // Ejecutar cuando cambie la longitud de las estructuras fijas sin filtrar

  const getData = async (hasContract: any = null, edit: boolean = false) => {
    removeLStorage('estEliminar')
    removeLStorage('estNuevo')
    removeLStorage('estGENuevo')
    removeLStorage('recFij')
    removeLStorage('recFijRec')
    removeLStorage('recFijCD')
    removeLStorage('frecEstructura')
    removeLStorage('frecIngrediente')
    removeLStorage('frecCD')
    removeLStorage('estIDGENuevo')

    try {
      const [
        dataSitios,
        dataRegimen,
        dataGrupoEstructuras,
        dataTipoPlato,
        dataIntolerancias,
        dataAlegenos,
        dataEstructuraFijas,
        dataRecetaEstructuraFijas,
        dataCategoriaDietetica,
        dataUsuariosSitios,
        dataIngAdyacentes,
        dataContractList,
      ] = await Promise.all([
        callSP('amd_getSitio', []),
        callSP('amd_getRegimen', []),
        callSP('amd_getGrupoEstructura', []),
        callSP('amd_getTipoPlato', []),
        callSP('amd_getIntolerancia', []),
        callSP('amd_getAlergenos', []),
        callSP('amd_getTipoEstructuraFija', []),
        callSP('amd_getRecetaEstructuraFija', []),
        callSP('amd_getCategoriaDietetica', []),
        callSP('amd_getUsuarioSitio', []),
        callSP('amd_getAdyacenciaPlantilla', []),
        callSP('amd_getContratos', []),
      ])
      setIngAdyacentes(dataIngAdyacentes.data.result)
      setSitios(
        dataSitios.data.result.map((e: any) => {
          return {
            ...e,
            text: `${e.cli_codigo} - ${e.cli_nombre}`,
            value: e.cli_codigo,
          }
        })
      )
      setRegimens(
        dataRegimen.data.result.map((e: any) => {
          return {
            ...e,
            text: `${e.reg_codigo} - ${e.reg_nombre}`,
            value: e.reg_codigo,
          }
        })
      )
      setGrupoEstructuras(
        dataGrupoEstructuras.data.result.map((e: any) => {
          return {
            ...e,
            text: e.tipo_estructura,
            value: e.id_grupo_estructura,
          }
        })
      )
      const tipoP: any[] = dataTipoPlato.data.result.map((e: any) => {
        return {
          ...e,
          text: e.tip_nombre.toString(),
          value: e.tip_codigo.toString(),
        }
      })
      setContractList(dataContractList.data.result)
      setTipoPlatos(tipoP)
      setIntolerancias(
        dataIntolerancias.data.result.map((e: any) => {
          return {
            ...e,
            text: e.NombreIntolerancia,
            value: e.IdIntolerancia,
          }
        })
      )
      setAlergenos(
        dataAlegenos.data.result.map((e: any) => {
          return {
            ...e,
            text: e.NombreAlergeno,
            value: e.IdAlergeno,
          }
        })
      )
      setEstructuraFijas(
        dataEstructuraFijas.data.result.map((e: any) => {
          return {
            ...e,
            text: e.descripcion,
            value: e.id,
          }
        })
      )
      setRecetaEstructuraFijas(
        dataRecetaEstructuraFijas.data.result.map((e: any) => {
          return {
            ...e,
            text: e.rec_nombre,
            value: e.rec_codigo,
          }
        })
      )
      setUsuariosSitios(
        dataUsuariosSitios.data.result.map((e: any) => {
          return {
            ...e,
            text: e.rec_nombre,
            value: e.rec_codigo,
          }
        })
      )

      setCategoriaDietetica(
        dataCategoriaDietetica.data.result.map((e: any) => {
          return {
            ...e,
            text: e.car_nombre.toString(),
            value: e.car_codigo,
          }
        })
      )

      if (edit) {
        // CRÍTICO: Limpiar localStorage cuando se edita un contrato
        // Esto evita que se usen estructuras seleccionadas de creaciones anteriores
        localStorage.removeItem('contratoOrigenSeleccionado')
        localStorage.removeItem('contratoBase')
        localStorage.removeItem('templateHomologada2')
        localStorage.removeItem('homologada2')
        localStorage.removeItem('estructurasSeleccionadas')
        localStorage.removeItem('estructurasSeleccionadasConNombres') // CRÍTICO: También limpiar los nombres
        localStorage.removeItem('estructurasMultiples')
        localStorage.removeItem('estructurasFijasSeleccionadas')
        localStorage.removeItem('estructurasFijasMultiples')
        
        // CRÍTICO: Establecer editContract ANTES de llamar a getDataEdit para que los useEffect sepan que están en modo edición
        setEditContract(true)
        getDataEdit(hasContract, tipoP, dataContractList.data.result, false, {id: '0'}, true)
      } else {
        setIsReady(true)
        setEditContract(false)
        setLoad(false)
      }
    } catch (e: any) {
      setLoad(false)
    }
  }

  // Función auxiliar para validar y filtrar dataRow2 antes de establecerlo
  // SOLO permite estructuras de contratos seleccionados al inicio Y estructuras específicas seleccionadas en el modal
  // En modo edición, NO filtra y devuelve todas las estructuras
  const validarYFiltrarDataRow2 = (dataRow2Array: any[], contrato: any, datosContrato?: any, modoEdicion: boolean = false): any[] => {
    // CRÍTICO: En modo edición, NO filtrar - devolver todas las estructuras
    if (modoEdicion) {
      return dataRow2Array
    }
    // Obtener contratos permitidos (ya incluye todos los seleccionados: Origen + Destino Multiple)
    const contratosPermitidos = obtenerContratosSeleccionadosAlInicio(datosContrato || {data: {result: []}}, contrato)
    const contratosPermitidosFinales = Array.from(new Set(contratosPermitidos.map((id: any) => {
      const idNum = typeof id === 'string' ? parseInt(id) : id
      return idNum
    }).filter((id: any) => id && !isNaN(id))))
    
    // CRÍTICO: Obtener las estructuras NORMALES específicas que el usuario seleccionó en el modal
    let idsEstructurasNormalesSeleccionadas: Set<string> = new Set()
    
    try {
      const estructurasSeleccionadasStr = localStorage.getItem('estructurasSeleccionadas')
      if (estructurasSeleccionadasStr && estructurasSeleccionadasStr !== '[]' && estructurasSeleccionadasStr !== '') {
        const estructurasSeleccionadas = JSON.parse(estructurasSeleccionadasStr)
        if (Array.isArray(estructurasSeleccionadas)) {
          estructurasSeleccionadas.forEach((id: any) => {
            if (id) idsEstructurasNormalesSeleccionadas.add(id.toString())
          })
        }
      }
      
      // También obtener estructuras de contratos múltiples
      const estructurasMultiplesStr = localStorage.getItem('estructurasMultiples')
      if (estructurasMultiplesStr && estructurasMultiplesStr !== '[]' && estructurasMultiplesStr !== '') {
        const estructurasMultiples = JSON.parse(estructurasMultiplesStr)
        if (Array.isArray(estructurasMultiples)) {
          estructurasMultiples.forEach((est: any) => {
            // Agregar TODOS los IDs posibles
            if (est.id) idsEstructurasNormalesSeleccionadas.add(est.id?.toString())
            if (est.ess_codigo) idsEstructurasNormalesSeleccionadas.add(est.ess_codigo?.toString())
            if (est.id_estructura) idsEstructurasNormalesSeleccionadas.add(est.id_estructura?.toString())
            if (est.id_estructura_contrato) idsEstructurasNormalesSeleccionadas.add(est.id_estructura_contrato?.toString())
          })
        }
      }
    } catch (e) {
    }
    
    // Filtrar estructuras
    const dataRow2Filtrado = dataRow2Array.filter((item: any) => {
      const contratoItem = item.contrato
      const contratoItemNum = contratoItem ? (typeof contratoItem === 'string' ? parseInt(contratoItem) : contratoItem) : null
      
      // 1. Verificar que el contrato esté en la lista permitida
      const contratoPermitido = contratoItemNum && contratosPermitidosFinales.includes(contratoItemNum)
      if (!contratoPermitido) {
        return false
      }
      
      // 2. Si hay estructuras específicas seleccionadas, verificar que esta estructura esté en la lista
      if (idsEstructurasNormalesSeleccionadas.size > 0) {
        // Obtener todos los IDs posibles de esta estructura
        const idsPosibles = [
          item.id?.toString(),
          item.idStru?.toString(),
          item.idStructure?.toString(),
          item.idEstRel?.toString(),
          item.id_estructura?.toString(),
          item.id_estructura_contrato?.toString()
        ].filter((id: any) => id && id !== 'undefined' && id !== 'null' && id !== '0')
        
        // Verificar si alguno de los IDs está en las estructuras seleccionadas
        const estructuraSeleccionada = idsPosibles.some((id: string) => idsEstructurasNormalesSeleccionadas.has(id))
        
        if (!estructuraSeleccionada) {
          return false
        }
      }
      
      return true
    })
    
    return dataRow2Filtrado
  }

  // Función auxiliar para obtener TODOS los contratos seleccionados al inicio
  // Devuelve: [Homologada Origen, ...Homologada Destino Multiple]
  const obtenerContratosSeleccionadosAlInicio = (datosContrato: any, contrato: any): any[] => {
    let todosLosContratos: any[] = []
    
    // 1. Contrato de Homologada Origen - Intentar desde localStorage primero, luego desde datosContrato
    let contratoOrigenId: any = null
    try {
      const contratoOrigenStr = localStorage.getItem('contratoOrigenSeleccionado')
      if (contratoOrigenStr && contratoOrigenStr !== '' && contratoOrigenStr !== 'null' && contratoOrigenStr !== 'undefined') {
        contratoOrigenId = parseInt(contratoOrigenStr)
        if (!isNaN(contratoOrigenId) && contratoOrigenId > 0) {
          todosLosContratos.push(contratoOrigenId)
        }
      }
    } catch (e) {
      // Error silencioso
    }
    
    // Si no está en localStorage, intentar obtenerlo desde datosContrato (modo edición)
    if (!contratoOrigenId) {
      try {
        const dataContr: any = datosContrato.data?.result?.[0]
        if (dataContr?.id_contrato_rel && dataContr.id_contrato_rel > 0) {
          contratoOrigenId = dataContr.id_contrato_rel
          todosLosContratos.push(contratoOrigenId)
        }
        
        // CRÍTICO: También obtener id_contrato_rel2 (contratos homologados múltiples)
        if (dataContr?.id_contrato_rel2) {
          try {
            // id_contrato_rel2 puede ser un string con IDs separados por comas o punto y coma: "4294,5678,9012" o "1161;4179"
            const contratosRel2Str = dataContr.id_contrato_rel2.toString().trim()
            
            if (contratosRel2Str !== '' && contratosRel2Str !== 'null' && contratosRel2Str !== 'undefined') {
              // Dividir por comas o punto y coma y convertir a números
              const contratosRel2 = contratosRel2Str
                .split(/[,;]/)
                .map((id: string) => parseInt(id.trim()))
                .filter((id: number) => !isNaN(id) && id > 0)
              
              if (contratosRel2.length > 0) {
                todosLosContratos.push(...contratosRel2)
              }
            }
          } catch (e) {
            // Error al parsear id_contrato_rel2
          }
        }
      } catch (e) {
        // Error silencioso
      }
    }
    
    // 2. Contratos seleccionados en Homologada Destino Multiple - desde localStorage
    // IMPORTANTE: No limpiar localStorage aquí si ya se obtuvieron contratos desde BD (modo edición)
    const yaSeObtuvieronContratosDeBD = todosLosContratos.length > 0
    
    try {
      const homologada2Str = localStorage.getItem('homologada2')
      const homologada2Marcado = homologada2Str === 'true'
      
      const templateHomologada2Str = localStorage.getItem('templateHomologada2')
      
      // Usar templateHomologada2 si está marcado
      if (homologada2Marcado && templateHomologada2Str && templateHomologada2Str !== '[]' && templateHomologada2Str !== '' && templateHomologada2Str !== 'null' && templateHomologada2Str !== 'undefined') {
        const templateHomologada2 = JSON.parse(templateHomologada2Str)
        if (Array.isArray(templateHomologada2) && templateHomologada2.length > 0) {
          const contratosDestinoMultiple = templateHomologada2
            .map((item: any) => typeof item === 'object' && item !== null ? (item.value || item) : item)
            .map((id: any) => typeof id === 'string' ? parseInt(id) : id)
            .filter((id: any) => id && !isNaN(id) && id > 0)
          
          todosLosContratos = [...todosLosContratos, ...contratosDestinoMultiple]
        }
      }
      // NOTA: No limpiar templateHomologada2 si ya se obtuvieron contratos de BD (modo edición)
      // ya que esos contratos pueden venir de id_contrato_rel2 y no del localStorage
    } catch (e) {
      // Error silencioso
    }
    
    // Si no hay contratos en localStorage (modo edición), usar el contrato actual
    if (todosLosContratos.length === 0) {
      const contratoIdNum = typeof contrato.id === 'string' ? parseInt(contrato.id) : contrato.id
      if (contratoIdNum && !isNaN(contratoIdNum) && contratoIdNum > 0) {
        todosLosContratos.push(contratoIdNum)
      }
    }
    
    // Eliminar duplicados
    todosLosContratos = Array.from(new Set(todosLosContratos))
    
    return todosLosContratos
  }

  const getDataEdit = async (
    contrato: any,
    tp: any,
    contrsList: any,
    isLoad: boolean = false,
    contratoOrigen: any = {id: '0'},
    modoEdicion: boolean = false
  ) => {
    // Variable para guardar las estructuras validadas y usarlas en el filtro de dataRow3
    let estructurasValidadasParaFiltro: any[] = []
    
    const contratoBody: any = [{text: 'contrato', value: contrato.id.toString()}]
    const contratoIdNum = typeof contrato.id === 'string' ? parseInt(contrato.id) : contrato.id
    
    // Obtener datos básicos del contrato (necesarios para otras operaciones)
    // Estos se llaman con contrato.id porque son datos básicos necesarios para el funcionamiento
    const [
      datosContrato,
      dataDiasSemana,
    ] = await Promise.all([
      callSP('amd_getDatosContrato', contratoBody),
      callSP('amd_getDiaSemanaByContrato', contratoBody),
    ])
    
    // Obtener contratos seleccionados al inicio ANTES de llamar a amd_getDatosByContrato
    // En modo edición, esto debería devolver el contrato actual o el contrato homologado
    const contratosSeleccionadosIniciales = obtenerContratosSeleccionadosAlInicio(datosContrato, contrato)
    const contratosSeleccionadosNormalizados = Array.from(new Set(contratosSeleccionadosIniciales.map((id: any) => {
      return typeof id === 'string' ? parseInt(id) : id
    }).filter((id: any) => id && !isNaN(id))))
    
    // contratoIdNum ya está definido arriba
    const contratoEstaSeleccionado = contratosSeleccionadosNormalizados.includes(contratoIdNum)
    
    // CRÍTICO: En modo edición, SIEMPRE cargar datos del contrato actual
    // En modo creación, solo cargar si está seleccionado
    let dataDatosByContrato: any = {data: {result: []}}
    if (contratoEstaSeleccionado || modoEdicion) {
      dataDatosByContrato = await callSP('amd_getDatosByContrato', [
        {text: 'contrato', value: contrato.id.toString()},
        {text: 'id_minuta', value: ''},
      ])
    }

    setDatosByContrato(dataDatosByContrato.data.result)
    setDatosContrato(datosContrato.data.result)
    setDiasSemana(dataDiasSemana.data.result)
    
    // CRÍTICO: Obtener SOLO contratos explícitamente en localStorage (NO usar obtenerContratosSeleccionadosAlInicio)
    // Esto evita que se agregue automáticamente el contrato.id (7686) cuando no está seleccionado
    let contratoOrigenExplicito: any = null
    let contratosDestinoMultipleExplicito: any[] = []
    
    try {
      const contratoOrigenStr = localStorage.getItem('contratoOrigenSeleccionado')
      if (contratoOrigenStr && contratoOrigenStr !== '' && contratoOrigenStr !== 'null' && contratoOrigenStr !== 'undefined') {
        const parsed = parseInt(contratoOrigenStr)
        if (!isNaN(parsed) && parsed > 0) {
          contratoOrigenExplicito = parsed
        }
      }
    } catch (e) {}
    
    try {
      // CRÍTICO: Verificar que el checkbox homologada2 esté marcado antes de usar templateHomologada2
      const homologada2Str = localStorage.getItem('homologada2')
      const homologada2Marcado = homologada2Str === 'true'
      
      const templateHomologada2Str = localStorage.getItem('templateHomologada2')
      
      // Solo usar templateHomologada2 si el checkbox está marcado
      if (homologada2Marcado && templateHomologada2Str && templateHomologada2Str !== '[]' && templateHomologada2Str !== '' && templateHomologada2Str !== 'null' && templateHomologada2Str !== 'undefined') {
        const templateHomologada2 = JSON.parse(templateHomologada2Str)
        if (Array.isArray(templateHomologada2) && templateHomologada2.length > 0) {
          contratosDestinoMultipleExplicito = templateHomologada2
            .map((item: any) => typeof item === 'object' && item !== null ? (item.value || item) : item)
            .map((id: any) => typeof id === 'string' ? parseInt(id) : id)
            .filter((id: any) => id && !isNaN(id) && id > 0)
        }
      } else if (!homologada2Marcado) {
        // Si el checkbox NO está marcado, limpiar templateHomologada2
        localStorage.removeItem('templateHomologada2')
        contratosDestinoMultipleExplicito = []
      }
    } catch (e) {}
    
    const contratosPermitidosExplicitos = [contratoOrigenExplicito, ...contratosDestinoMultipleExplicito].filter((id: any) => id && !isNaN(id))
    
    // CRÍTICO: En modo edición, usar SOLO el ID del contrato que se está editando
    // NO usar los contratos "padre" (id_contrato_rel, id_contrato_rel2) porque el contrato editado ya tiene sus propias estructuras
    let contratosUnicosProcedimientos = Array.from(new Set(contratosPermitidosExplicitos))
    
    if (modoEdicion) {
      // Modo edición: usar SOLO el ID del contrato que se está editando
      contratosUnicosProcedimientos = [contratoIdNum]
    } else if (contratosUnicosProcedimientos.length === 0) {
      // Modo creación sin contratos seleccionados: no cargar nada
    }
    
    // Cargar estructurasMultiples solo para uso posterior (no para procedimientos)
    let estructurasMultiples: any[] = []
    try {
      const estructurasMultiplesStr = localStorage.getItem('estructurasMultiples')
      if (estructurasMultiplesStr && estructurasMultiplesStr !== '[]' && estructurasMultiplesStr !== '') {
        estructurasMultiples = JSON.parse(estructurasMultiplesStr)
        if (!Array.isArray(estructurasMultiples)) {
          estructurasMultiples = []
        }
      }
    } catch (e) {
      estructurasMultiples = []
    }
    
    // Cargar estructuras fijas, reglas y estructuras SOLO de contratos seleccionados al inicio
    let todasEstructurasFijas: any[] = []
    let todasReglas: any[] = []
    let todasEstructuras: any[] = []
    
    if (contratosUnicosProcedimientos.length > 0) {
      const promesasProcedimientos = contratosUnicosProcedimientos.map(async (contratoId: any) => {
        try {
          const contratoIdNum = typeof contratoId === 'string' ? parseInt(contratoId) : contratoId
          
          if (!contratoIdNum || isNaN(contratoIdNum) || contratoIdNum <= 0) {
            return { estructurasFijas: [], reglas: [], estructuras: [] }
          }
          
          // VALIDACIÓN CRÍTICA: Verificar que el contrato esté realmente en la lista permitida
          // IMPORTANTE: En modo edición, NO validar contra localStorage (está vacío)
          if (!modoEdicion && !contratosPermitidosExplicitos.includes(contratoIdNum)) {
            return { estructurasFijas: [], reglas: [], estructuras: [] }
          }
          
          if (!modoEdicion && !contratosUnicosProcedimientos.includes(contratoIdNum)) {
            return { estructurasFijas: [], reglas: [], estructuras: [] }
          }
          
          
          const [dataEstructuraFijaMultiple, dataReglasMultiple, dataEstructuraMultiple]: any = await Promise.all([
            callSP('amd_getEstructuraFijaByContrato', [
              {text: 'contrato', value: contratoIdNum.toString()},
            ]),
            callSP('amd_getReglasByContrato', [
              {text: 'contrato', value: contratoIdNum.toString()},
            ]),
            callSP('amd_getEstructuraByContrato', [
              {text: 'contrato', value: contratoIdNum.toString()},
            ]),
          ])
          
          const resultados: any = {
            estructurasFijas: [],
            reglas: [],
            estructuras: []
          }
          
          if (dataEstructuraFijaMultiple?.data?.status === '200' && Array.isArray(dataEstructuraFijaMultiple.data.result)) {
            resultados.estructurasFijas = dataEstructuraFijaMultiple.data.result.map((e: any) => {
              // CRÍTICO: Asignar el contratoIdNum correcto (el que se está procesando en esta iteración)
              const estructuraConOrigen = {
                ...e,
                contratoOrigen: contratoIdNum // Usar el contratoIdNum de esta iteración específica
              }
              
              return estructuraConOrigen
            })
          }
          
          if (dataReglasMultiple?.data?.status === '200' && Array.isArray(dataReglasMultiple.data.result)) {
            resultados.reglas = dataReglasMultiple.data.result.map((e: any) => ({
              ...e,
              contratoOrigen: contratoIdNum
            }))
          }
          
          if (dataEstructuraMultiple?.data?.status === '200' && Array.isArray(dataEstructuraMultiple.data.result)) {
            resultados.estructuras = dataEstructuraMultiple.data.result.map((e: any) => ({
              ...e,
              contratoOrigen: contratoIdNum
            }))
          }
          
          return resultados
        } catch (e: any) {
          return { estructurasFijas: [], reglas: [], estructuras: [] }
        }
      })
      
      const resultadosMultiples = await Promise.all(promesasProcedimientos)
      
      todasEstructurasFijas = [
        ...todasEstructurasFijas,
        ...resultadosMultiples.flatMap((r: any) => r.estructurasFijas)
      ]
      
      todasReglas = [
        ...todasReglas,
        ...resultadosMultiples.flatMap((r: any) => r.reglas)
      ]
      
      todasEstructuras = [
        ...todasEstructuras,
        ...resultadosMultiples.flatMap((r: any) => r.estructuras)
      ]
    }
    
    // FILTRAR estructuras fijas: SOLO incluir las que fueron seleccionadas en el modal
    // IMPORTANTE: En modo edición, NO filtrar - usar TODAS las estructuras fijas cargadas
    let estructurasFijasSeleccionadasFiltradas: any[] = []
    
    if (modoEdicion) {
      // Modo edición: usar TODAS las estructuras fijas sin filtrar
      estructurasFijasSeleccionadasFiltradas = todasEstructurasFijas
    } else {
      // Modo creación: filtrar por las seleccionadas en el modal
      try {
        // Leer estructuras fijas del contrato base
        let estructurasFijasSeleccionadas: any[] = []
        const estructurasFijasSeleccionadasStr = localStorage.getItem('estructurasFijasSeleccionadas')
        if (estructurasFijasSeleccionadasStr && estructurasFijasSeleccionadasStr !== '[]' && estructurasFijasSeleccionadasStr !== '') {
          estructurasFijasSeleccionadas = JSON.parse(estructurasFijasSeleccionadasStr)
          if (!Array.isArray(estructurasFijasSeleccionadas)) {
            estructurasFijasSeleccionadas = []
          }
        }
        
        // Leer estructuras fijas de contratos múltiples
        let estructurasFijasMultiples: any[] = []
        const estructurasFijasMultiplesStr = localStorage.getItem('estructurasFijasMultiples')
        if (estructurasFijasMultiplesStr && estructurasFijasMultiplesStr !== '[]' && estructurasFijasMultiplesStr !== '') {
          estructurasFijasMultiples = JSON.parse(estructurasFijasMultiplesStr)
          if (!Array.isArray(estructurasFijasMultiples)) {
            estructurasFijasMultiples = []
          }
        }
        
        // Combinar ambas listas
        const todasEstructurasFijasSeleccionadas = [...estructurasFijasSeleccionadas, ...estructurasFijasMultiples]
        
        if (todasEstructurasFijasSeleccionadas.length > 0) {
          // Crear un Set de IDs de estructuras fijas seleccionadas para búsqueda rápida
          const estructurasFijasSeleccionadasMap = new Map()
          todasEstructurasFijasSeleccionadas.forEach((ef: any) => {
            const key = `${ef.contratoId || ''}-${ef.id_estructura || ef.id || ''}-${ef.id_receta || ''}`
            estructurasFijasSeleccionadasMap.set(key, ef)
          })
            
            // Filtrar todasEstructurasFijas para incluir solo las seleccionadas
            estructurasFijasSeleccionadasFiltradas = todasEstructurasFijas.filter((ef: any) => {
              const contratoOrigen = ef.contratoOrigen || ef.id_contrato || ''
              const idEstructura = ef.id_estructura || ef.id || ''
              const idReceta = ef.id_receta || ''
              
              // Buscar coincidencia por contrato + id_estructura + id_receta
              const key1 = `${contratoOrigen}-${idEstructura}-${idReceta}`
              const key2 = `${contratoOrigen}-${idEstructura}-`
              const key3 = `${contratoOrigen}-${ef.id}-${idReceta}`
              
              return estructurasFijasSeleccionadasMap.has(key1) || 
                     estructurasFijasSeleccionadasMap.has(key2) ||
                     estructurasFijasSeleccionadasMap.has(key3) ||
                     estructurasFijasSeleccionadas.some((efSel: any) => 
                       (efSel.contratoId === contratoOrigen || efSel.contratoId?.toString() === contratoOrigen?.toString()) &&
                       (efSel.id_estructura === idEstructura || efSel.id_estructura === ef.id || efSel.id === ef.id || efSel.id === idEstructura) &&
                       (!efSel.id_receta || efSel.id_receta === idReceta || !idReceta)
                     )
            })
            
        } else {
          // Si no hay estructuras fijas seleccionadas, no mostrar ninguna
          estructurasFijasSeleccionadasFiltradas = []
        }
      } catch (e: any) {
        estructurasFijasSeleccionadasFiltradas = todasEstructurasFijas
      }
    }
    
    setEstructuraFija(estructurasFijasSeleccionadasFiltradas)
    setReglas(todasReglas)
    setDataEstructuraByContrato(todasEstructuras)
    
    // Nota: setDatosByContrato y setDatosContrato ya se establecieron arriba con los datos básicos

    // step 1
    const dataContr: any = datosContrato.data.result[0]
    if (!isLoad) setSStorage('contractId', contrato.id.toString())

    const dataStep1: any = {
      contractId: isLoad ? contratoOrigen.id.toString() : contrato.id.toString(),
      idTemplate: dataContr?.id_tipo_plantilla.toString(),
      place: [
        {
          text: dataContr?.cli_nombre,
          value: dataContr?.cli_codigo.toString(),
        },
      ],
      service: [
        {
          text: dataContr?.ser_nombre,
          value: parseInt(dataContr?.ser_codigo),
        },
      ],
      regime: [
        {
          text: dataContr?.reg_nombre,
          value: parseInt(dataContr?.reg_codigo),
        },
      ],
      frequencyCycle: dataContr?.ciclo_minuta,
      frequencyType: [
        {
          text: getFrequencyTypeText(dataContr?.id_tipo_frecuencia.toString()),
          value: dataContr?.id_tipo_frecuencia,
        },
      ],
      templateType: [
        {
          text: getTemplateTypeText(dataContr?.id_tipo_plantilla.toString()),
          value: dataContr?.id_tipo_plantilla,
        },
      ],

      homologada: isLoad ? isLoad : dataContr?.id_contrato_rel > 0,
      templateHomologada: getContrHomologado(
        isLoad ? contrato.id : dataContr?.id_contrato_rel,
        contrsList
      ),
      
      // CRÍTICO: Cargar contratos múltiples desde id_contrato_rel2
      homologada2: false,
      templateHomologada2: [],

      monthlyCost: dataContr?.costo_objetivo_mensual,

      fechaCreacion: dataContr?.fecha_creacion,

      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,

      quantityMonday: undefined,
      quantityTuesday: undefined,
      quantityWednesday: undefined,
      quantityThursday: undefined,
      quantityFriday: undefined,
      quantitySaturday: undefined,
      quantitySunday: undefined,

      weeks: undefined,

      ruleColorDistribution: false,
      ruleRecipeRepeat: false,
      ruleDescriptiveCost: false,
      ruleGarnitureCruce: false,
      ruleNameRepeat: false,
      ruleRemoriceEfect: false,
      ruleComplexityRecipes: false,
      ruleCookingMethod: false,
      ruleCruceRule: false,
      reglaSitio: [],
      reglaRegimen: [],
      reglaServicios: [],
    }

    dataDiasSemana.data.result.forEach((e: any) => {
      if (e.n_dia == 1) {
        dataStep1.mondayId = isLoad ? '0' : e.id.toString()
        dataStep1.monday = e.estado == 1
        dataStep1.quantityMonday = e.q_comensales
      }
      if (e.n_dia == 2) {
        dataStep1.tuesdayId = isLoad ? '0' : e.id.toString()
        dataStep1.tuesday = e.estado == 1
        dataStep1.quantityTuesday = e.q_comensales
      }
      if (e.n_dia == 3) {
        dataStep1.wednesdayId = isLoad ? '0' : e.id.toString()
        dataStep1.wednesday = e.estado == 1
        dataStep1.quantityWednesday = e.q_comensales
      }
      if (e.n_dia == 4) {
        dataStep1.thursdayId = isLoad ? '0' : e.id.toString()
        dataStep1.thursday = e.estado == 1
        dataStep1.quantityThursday = e.q_comensales
      }
      if (e.n_dia == 5) {
        dataStep1.fridayId = isLoad ? '0' : e.id.toString()
        dataStep1.friday = e.estado == 1
        dataStep1.quantityFriday = e.q_comensales
      }
      if (e.n_dia == 6) {
        dataStep1.saturdayId = isLoad ? '0' : e.id.toString()
        dataStep1.saturday = e.estado == 1
        dataStep1.quantitySaturday = e.q_comensales
      }
      if (e.n_dia == 7) {
        dataStep1.sundayId = isLoad ? '0' : e.id.toString()
        dataStep1.sunday = e.estado == 1
        dataStep1.quantitySunday = e.q_comensales
      }
    })
    let arrayDays: any = []
    const qtyDays: any = dataDiasSemana.data.result
      .filter((item: any) => {
        if (!arrayDays.includes(item.n_dia)) {
          arrayDays.push(item.n_dia)
          return item
        }
      })
      .reduce((acc: number, cur: any) => (cur.estado == 1 ? acc + 1 : acc + 0), 0)
    if (dataStep1.templateType[0].value === 3) {
      dataStep1.weeks = 4
    } else {
      if (qtyDays) dataStep1.weeks = dataContr?.ciclo_minuta / qtyDays
      if (dataStep1.weeks < 1) {
        dataStep1.weeks = 0
      }
    }
    // step 6
    todasReglas.forEach((e: any) => {
      if (e.idRegla == 1) {
        dataStep1.ruleColorDistribution = e.estado == 1
      }
      if (e.idRegla == 2) {
        dataStep1.ruleRecipeRepeat = e.estado == 1
      }
      if (e.idRegla == 3) {
        dataStep1.ruleDescriptiveCost = e.estado == 1
      }
      if (e.idRegla == 4) {
        dataStep1.ruleGarnitureCruce = e.estado == 1
      }
      if (e.idRegla == 5) {
        dataStep1.ruleNameRepeat = e.estado == 1
      }
      if (e.idRegla == 6) {
        dataStep1.ruleRemoriceEfect = e.estado == 1
      }
      if (e.idRegla == 7) {
        dataStep1.ruleComplexityRecipes = e.estado == 1
      }
      if (e.idRegla == 8) {
        dataStep1.ruleCookingMethod = e.estado == 1
      }
      if (e.idRegla == 9) {
        dataStep1.ruleCruceRule = e.estado == 1
        dataStep1.reglaSitio = [
          {
            text: e.cli_nombre,
            value: e.idSitio,
          },
        ]
        dataStep1.reglaRegimen = [
          {
            text: e.reg_nombre,
            value: e.idRegimen,
          },
        ]
        dataStep1.reglaServicios = [
          {
            text: e.ser_nombre,
            value: e.idServicio,
          },
        ]
      }
    })
    
    // CRÍTICO: En modo edición, guardar el contrato origen en localStorage
    // para que los demás useEffect puedan encontrarlo
    if (modoEdicion && dataContr?.id_contrato_rel && dataContr.id_contrato_rel > 0) {
      localStorage.setItem('contratoOrigenSeleccionado', dataContr.id_contrato_rel.toString())
    }
    
    // CRÍTICO: Procesar id_contrato_rel2 para cargar contratos múltiples
    // PERO solo si estamos en modo edición real (no cuando se selecciona un contrato origen)
    if (modoEdicion && dataContr?.id_contrato_rel2) {
      try {
        const contratosRel2Str = dataContr.id_contrato_rel2.toString().trim()
        
        if (contratosRel2Str !== '' && contratosRel2Str !== 'null' && contratosRel2Str !== 'undefined') {
          // Dividir por comas o punto y coma y convertir a números
          const contratosRel2Ids = contratosRel2Str
            .split(/[,;]/)
            .map((id: string) => parseInt(id.trim()))
            .filter((id: number) => !isNaN(id) && id > 0)
          
          if (contratosRel2Ids.length > 0) {
            
            // Convertir IDs a formato de opciones para el dropdown
            const templateHomologada2 = contratosRel2Ids.map((id: number) => {
              const contratoData = getContrHomologado(id, contrsList)
              if (contratoData && contratoData.length > 0) {
                return contratoData[0]
              }
              // Si no se encuentra en la lista, crear un objeto básico
              return {
                text: `Contrato ${id}`,
                value: id
              }
            }).filter((c: any) => c !== null)
            
            dataStep1.homologada2 = true
            dataStep1.templateHomologada2 = templateHomologada2
            
            // CRÍTICO: También guardar en localStorage para que los demás useEffect los puedan usar
            localStorage.setItem('homologada2', 'true')
            localStorage.setItem('templateHomologada2', JSON.stringify(templateHomologada2))
            
          }
        }
      } catch (e) {
      }
    } else if (!modoEdicion && dataContr?.id_contrato_rel2) {
    }
    
    setEditDataStep1(dataStep1)
    
    const estructurasSeleccionadasStr = localStorage.getItem('estructurasSeleccionadas')
    const estructurasSeleccionadasIds = estructurasSeleccionadasStr ? JSON.parse(estructurasSeleccionadasStr) : []
    
    // Reutilizar estructurasMultiples que ya se cargó anteriormente
    
    // Obtener el contrato de Homologada Origen PRIMERO para usarlo en el filtrado
    let contratoOrigenStr = localStorage.getItem('contratoOrigenSeleccionado')
    let contratoOrigenId = contratoOrigenStr ? parseInt(contratoOrigenStr) : null
    
    // También intentar obtenerlo desde datosContrato si no está en localStorage
    if (!contratoOrigenId) {
      try {
        const dataContr: any = datosContrato.data.result?.[0]
        if (dataContr?.id_contrato_rel && dataContr.id_contrato_rel > 0) {
          contratoOrigenId = dataContr.id_contrato_rel
        }
      } catch (e) {
      }
    }
    
    // VALIDACIÓN CRÍTICA: Filtrar datos del contrato base para SOLO incluir registros del contrato base
    // Esto previene que se incluyan estructuras de otros contratos que puedan venir en la respuesta
    
    // Si el contrato de Homologada Origen es igual al contrato base, marcar las estructuras del base con contratoOrigen
    const contratoOrigenEsBase = contratoOrigenId && contratoOrigenId === contrato.id
    
    // SIMPLIFICADO: Filtrar datos del contrato base para SOLO incluir registros del contrato base
    // y marcarlos con el ID del contrato base
    const contratoIdBaseNum = typeof contrato.id === 'string' ? parseInt(contrato.id) : contrato.id
    
    let datosFiltrados = dataDatosByContrato.data.result.filter((item: any) => {
      // Obtener el ID del contrato del registro
      const idContratoItem = item.id_contrato
      const contratoOrigenItem = item.contratoOrigen
      
      // Normalizar IDs para comparación
      const idContratoNum = idContratoItem ? (typeof idContratoItem === 'string' ? parseInt(idContratoItem) : idContratoItem) : null
      const contratoOrigenNum = contratoOrigenItem ? (typeof contratoOrigenItem === 'string' ? parseInt(contratoOrigenItem) : contratoOrigenItem) : null
      
      // El registro debe pertenecer al contrato base si:
      // 1. id_contrato coincide con el contrato base, O
      // 2. contratoOrigen coincide con el contrato base, O
      // 3. No tiene ninguno de los dos (asumir que es del contrato base)
      const esDelContratoBase = (idContratoNum === contratoIdBaseNum) ||
                                (contratoOrigenNum === contratoIdBaseNum) ||
                                (!idContratoNum && !contratoOrigenNum)
      
      return esDelContratoBase
    }).map((item: any) => ({
      ...item,
      contratoOrigen: contratoIdBaseNum,
      id_contrato: contratoIdBaseNum
    }))
    
    // PRIMERO: Obtener TODOS los contratos seleccionados al inicio ANTES de procesar datos
    // CRÍTICO: Usar SOLO contratos explícitamente en localStorage (NO usar obtenerContratosSeleccionadosAlInicio)
    let contratoOrigenExplicitoDatosByContrato: any = null
    let contratosDestinoMultipleExplicitoDatosByContrato: any[] = []
    
    try {
      const contratoOrigenStrDatosByContrato = localStorage.getItem('contratoOrigenSeleccionado')
      if (contratoOrigenStrDatosByContrato && contratoOrigenStrDatosByContrato !== '' && contratoOrigenStrDatosByContrato !== 'null' && contratoOrigenStrDatosByContrato !== 'undefined') {
        const parsed = parseInt(contratoOrigenStrDatosByContrato)
        if (!isNaN(parsed) && parsed > 0) {
          contratoOrigenExplicitoDatosByContrato = parsed
        }
      }
    } catch (e) {}
    
    try {
      // CRÍTICO: Verificar que el checkbox homologada2 esté marcado antes de usar templateHomologada2
      const homologada2StrDatosByContrato = localStorage.getItem('homologada2')
      const homologada2MarcadoDatosByContrato = homologada2StrDatosByContrato === 'true'
      
      const templateHomologada2StrDatosByContrato = localStorage.getItem('templateHomologada2')
      
      // Solo usar templateHomologada2 si el checkbox está marcado
      if (homologada2MarcadoDatosByContrato && templateHomologada2StrDatosByContrato && templateHomologada2StrDatosByContrato !== '[]' && templateHomologada2StrDatosByContrato !== '' && templateHomologada2StrDatosByContrato !== 'null' && templateHomologada2StrDatosByContrato !== 'undefined') {
        const templateHomologada2 = JSON.parse(templateHomologada2StrDatosByContrato)
        if (Array.isArray(templateHomologada2) && templateHomologada2.length > 0) {
          contratosDestinoMultipleExplicitoDatosByContrato = templateHomologada2
            .map((item: any) => typeof item === 'object' && item !== null ? (item.value || item) : item)
            .map((id: any) => typeof id === 'string' ? parseInt(id) : id)
            .filter((id: any) => id && !isNaN(id) && id > 0)
        }
      } else if (!homologada2MarcadoDatosByContrato) {
        contratosDestinoMultipleExplicitoDatosByContrato = []
      }
    } catch (e) {}
    
    const contratosPermitidosExplicitosDatosByContrato = [contratoOrigenExplicitoDatosByContrato, ...contratosDestinoMultipleExplicitoDatosByContrato].filter((id: any) => id && !isNaN(id))
    
    // CRÍTICO: En modo edición, usar SOLO el ID del contrato que se está editando
    // NO usar los contratos "padre" porque el contrato editado ya tiene sus propias estructuras guardadas
    let contratosUnicosFinales = Array.from(new Set(contratosPermitidosExplicitosDatosByContrato))
    
    if (modoEdicion) {
      // Modo edición: usar SOLO el ID del contrato que se está editando
      contratosUnicosFinales = [contratoIdNum]
    } else if (contratosUnicosFinales.length === 0) {
      // Modo creación sin contratos seleccionados: no cargar nada
    }
    
    // IMPORTANTE: Solo incluir datos del contrato base si está en la lista de seleccionados
    const contratoIdNumBase = typeof contrato.id === 'string' ? parseInt(contrato.id) : contrato.id
    
    if (contratosUnicosFinales.includes(contratoIdNumBase)) {
      // CRÍTICO: En modo edición, cargar TODAS las estructuras del contrato
      // En modo creación, SOLO cargar estructuras que fueron seleccionadas en el modal
      if (modoEdicion) {
        // Modo edición: cargar todas las estructuras del contrato
      } else if (estructurasSeleccionadasIds.length > 0) {
        // Modo creación: filtrar por estructuras seleccionadas
        datosFiltrados = datosFiltrados.filter((item: any) => {
          return estructurasSeleccionadasIds.includes(item.id_estructura_contrato)
        })
        
        const estructurasUnicas = new Set(datosFiltrados.map((e: any) => e.id_estructura_contrato))
      } else {
        // Modo creación sin estructuras seleccionadas: NO cargar ninguna estructura
        datosFiltrados = []
      }
      
      // Marcar los datos del contrato base con su ID para que pasen el filtro
      datosFiltrados = datosFiltrados.map((item: any) => ({
        ...item,
        contratoOrigen: contratoIdNumBase,
        id_contrato: contratoIdNumBase
      }))
    } else {
      // Si el contrato base NO está en la lista de seleccionados, NO incluir sus datos
      datosFiltrados = []
    }
    
    // Cargar amd_getDatosByContrato SOLO para contratos seleccionados al inicio
    let datosContratosMultiples: any[] = []
    
    // Validar que estructurasMultiples solo contenga contratos seleccionados al inicio
    const contratosEnEstructurasMultiples = Array.from(new Set(estructurasMultiples.map((e: any) => e.contratoId)))
    const contratosNoSeleccionadosEnMultiples = contratosEnEstructurasMultiples.filter((id: any) => {
      const idNum = typeof id === 'string' ? parseInt(id) : id
      return !contratosUnicosFinales.includes(idNum)
    })
    
    // LOG ENFOCADO: Ver qué estructuras hay guardadas por contrato
    const estructurasPorContratoCount = new Map<number, number>()
    estructurasMultiples.forEach((e: any) => {
      const contratoId = typeof e.contratoId === 'string' ? parseInt(e.contratoId) : e.contratoId
      if (contratoId) {
        estructurasPorContratoCount.set(contratoId, (estructurasPorContratoCount.get(contratoId) || 0) + 1)
      }
    })
    
    if (contratosUnicosFinales.length > 0) {
      const promesasContratos = contratosUnicosFinales.map(async (contratoId: any) => {
        try {
          const contratoIdNum = typeof contratoId === 'string' ? parseInt(contratoId) : contratoId
          const datosContratoMultiple: any = await callSP('amd_getDatosByContrato', [
            {text: 'contrato', value: contratoIdNum ? contratoIdNum.toString() : '0'},
            {text: 'id_minuta', value: ''},
          ])
          
          if (datosContratoMultiple?.data?.result) {
            // Para contratos seleccionados al inicio, traer TODAS las estructuras del contrato
            // Solo filtrar si hay estructuras seleccionadas específicamente para este contrato
            let datosFiltradosContrato = datosContratoMultiple.data.result
            
            // Filtrar estructurasMultiples para SOLO incluir estructuras de contratos seleccionados al inicio
            const estructurasMultiplesFiltradas = estructurasMultiples.filter((e: any) => {
              const eContratoIdNum = typeof e.contratoId === 'string' ? parseInt(e.contratoId) : e.contratoId
              return contratosUnicosFinales.includes(eContratoIdNum)
            })
            
            // CRÍTICO: SOLO cargar estructuras que fueron seleccionadas en el modal
            // Si no hay estructuras seleccionadas para este contrato, NO cargar ninguna estructura
            const estructurasIdsDeEsteContrato = estructurasMultiplesFiltradas
              .filter((e: any) => {
                const eContratoIdNum = typeof e.contratoId === 'string' ? parseInt(e.contratoId) : e.contratoId
                return eContratoIdNum === contratoIdNum
              })
              .map((e: any) => e.id)
            
            // CRÍTICO: En modo edición, cargar TODAS las estructuras del contrato
            // En modo creación, SOLO cargar estructuras seleccionadas
            if (modoEdicion) {
              // Modo edición: cargar todas las estructuras
              datosFiltradosContrato = datosContratoMultiple.data.result
            } else if (estructurasIdsDeEsteContrato.length > 0) {
              // Modo creación: filtrar SOLO las estructuras seleccionadas en el modal
              datosFiltradosContrato = datosContratoMultiple.data.result.filter((item: any) => {
                return estructurasIdsDeEsteContrato.includes(item.id_estructura_contrato) ||
                       estructurasIdsDeEsteContrato.includes(item.id_estructura) ||
                       estructurasIdsDeEsteContrato.includes(item.cod_estructura)
              })
              
              const estructurasUnicas = new Set(datosFiltradosContrato.map((e: any) => e.id_estructura_contrato))
            } else {
              // Modo creación sin estructuras seleccionadas: NO cargar ninguna estructura
              datosFiltradosContrato = []
            }
            
            // IMPORTANTE: Establecer tanto contratoOrigen como id_contrato para asegurar filtrado correcto
            // Esto asegura que cada estructura tenga el ID del contrato al que pertenece
            const datosMarcados = datosFiltradosContrato.map((item: any) => ({
              ...item,
              contratoOrigen: contratoIdNum,
              id_contrato: contratoIdNum // Asegurar que id_contrato también sea el contrato correcto
            }))
            
            // LOG ENFOCADO: Ver cuántos registros se obtuvieron de este contrato
            return datosMarcados
          }
          return []
        } catch (e: any) {
          return []
        }
      })
      
      const resultados = await Promise.all(promesasContratos)
      datosContratosMultiples = resultados.flat()
      
      // LOG ENFOCADO: Resumen final de contratos procesados
    }
    
    datosFiltrados = [...datosFiltrados, ...datosContratosMultiples]
    
    // CRÍTICO: Usar la misma lista normalizada que se usó para cargar los datos
    // Esto asegura que los contratos permitidos coincidan exactamente con los contratos cargados
    const contratosPermitidos = contratosUnicosFinales
    
    // FILTRADO ESTRICTO: SOLO incluir registros donde id_contrato o contratoOrigen esté EXPLÍCITAMENTE en la lista permitida
    const datosFiltradosFinales = datosFiltrados.filter((item: any) => {
      // Obtener el ID del contrato del registro
      const contratoOrigen = item.contratoOrigen
      const idContrato = item.id_contrato
      
      // Normalizar IDs para comparación
      const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
      const idContratoNum = idContrato ? (typeof idContrato === 'string' ? parseInt(idContrato) : idContrato) : null
      
      // REGLA ESTRICTA: El registro DEBE tener un id_contrato o contratoOrigen que esté EXPLÍCITAMENTE en la lista permitida
      // NO asumir nada, NO usar valores por defecto
      let estaPermitido = false
      
      if (contratoOrigenNum && contratosPermitidos.includes(contratoOrigenNum)) {
        estaPermitido = true
      } else if (idContratoNum && contratosPermitidos.includes(idContratoNum)) {
        estaPermitido = true
      }
      
      return estaPermitido
    })
    
    // CRÍTICO: Primero eliminar duplicados ANTES de agrupar para evitar duplicación del primer contrato
    // Un registro está duplicado si tiene el mismo id_estructura_contrato, contrato y orden
    const datosSinDuplicadosAntesAgrupar = new Map<string, any>()
    datosFiltradosFinales.forEach((item: any) => {
      const contratoOrigen = item.contratoOrigen || item.id_contrato
      const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
      const idEstructuraContrato = item.id_estructura_contrato
      const orden = item.orden || 0
      
      // Crear una clave única: id_estructura_contrato-contrato-orden
      const keyUnicoAntesAgrupar = `${idEstructuraContrato}-${contratoOrigenNum || 'sin_contrato'}-${orden}`
      
      if (!datosSinDuplicadosAntesAgrupar.has(keyUnicoAntesAgrupar)) {
        datosSinDuplicadosAntesAgrupar.set(keyUnicoAntesAgrupar, item)
      }
    })
    
    const datosFiltradosSinDuplicados = Array.from(datosSinDuplicadosAntesAgrupar.values())
    
    // CRÍTICO: Agrupar por una clave única que incluya id_estructura_contrato Y contrato
    // Esto evita que estructuras de diferentes contratos se agrupen juntas y se repitan
    const gruop: any = {}
    datosFiltradosSinDuplicados.forEach((item: any) => {
      const contratoOrigen = item.contratoOrigen || item.id_contrato
      const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
      const idEstructuraContrato = item.id_estructura_contrato
      
      // Crear una clave única: id_estructura_contrato-contrato
      const key = `${idEstructuraContrato}-${contratoOrigenNum || 'sin_contrato'}`
      
      if (!gruop[key]) {
        gruop[key] = []
      }
      gruop[key].push(item)
    })
    
    const dataStep2: any = []
    
    // CRÍTICO: Crear un mapa de dias_bloqueados desde amd_getEstructuraByContrato
    // El procedimiento amd_getEstructuraByContrato tiene el campo dias_bloqueados que falta en amd_getDatosByContrato
    // En amd_getEstructuraByContrato, el id_estructura_contrato viene como "id" o "idO", no como "id_estructura_contrato"
    const mapaDiasBloqueados = new Map<string, string>()
    todasEstructuras.forEach((estructura: any) => {
      // En amd_getEstructuraByContrato, el campo id_estructura_contrato viene como "id" o "idO"
      const idEstructuraContrato = estructura.id || estructura.idO || estructura.id_estructura_contrato
      const codEstructura = estructura.cod_estructura
      const idEstructura = estructura.id_estructura
      const contratoOrigen = estructura.contratoOrigen
      
      // Solo procesar si tiene dias_bloqueados y no está vacío
      if (!estructura.dias_bloqueados || estructura.dias_bloqueados.trim() === '') {
        return
      }
      
      // Crear claves únicas para el mapa usando múltiples identificadores
      if (idEstructuraContrato && contratoOrigen) {
        const key1 = `${idEstructuraContrato}-${contratoOrigen}`
        mapaDiasBloqueados.set(key1, estructura.dias_bloqueados)
      }
      if (codEstructura && contratoOrigen) {
        const key2 = `${codEstructura}-${contratoOrigen}`
        if (!mapaDiasBloqueados.has(key2)) {
          mapaDiasBloqueados.set(key2, estructura.dias_bloqueados)
        }
      }
      if (idEstructura && contratoOrigen) {
        const key3 = `${idEstructura}-${contratoOrigen}`
        if (!mapaDiasBloqueados.has(key3)) {
          mapaDiasBloqueados.set(key3, estructura.dias_bloqueados)
        }
      }
    })
    
    // Asegurar que contratoOrigenId esté disponible en el scope del forEach
    // (ya está declarado arriba, pero verificamos que esté disponible)
    if (!contratoOrigenId) {
      contratoOrigenStr = localStorage.getItem('contratoOrigenSeleccionado')
      contratoOrigenId = contratoOrigenStr ? parseInt(contratoOrigenStr) : null
    }
    
    // Filtrar grupos para solo incluir estructuras de contratos permitidos
    // REGLA ESTRICTA: SOLO incluir grupos donde el contrato esté EXPLÍCITAMENTE en la lista permitida
    const gruposFiltrados = Object.values(gruop).filter((e: any) => {
      const contratoOrigen = e[0]?.contratoOrigen
      const idContratoItem = e[0]?.id_contrato
      
      const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
      const idContratoNum = idContratoItem ? (typeof idContratoItem === 'string' ? parseInt(idContratoItem) : idContratoItem) : null
      
      // REGLA ESTRICTA: El grupo DEBE tener un contratoOrigen o id_contrato que esté EXPLÍCITAMENTE en la lista permitida
      const estaPermitido = (contratoOrigenNum && contratosPermitidos.includes(contratoOrigenNum)) ||
                           (idContratoNum && contratosPermitidos.includes(idContratoNum))
      
      return estaPermitido
    })
    
    // CRÍTICO: Usar Promise.all en lugar de forEach para esperar todas las promesas
    const items = await Promise.all(gruposFiltrados.map(async (e: any, key: number) => {
      // Tipo plato
      const findedPlato: any = tp.find((p: any) => e[0].tipo_plato == p.tip_codigo)
      let arrTP: any[] = []
      if (findedPlato.tip_previo == 0) {
        const tt: any[] = await getPlateTypesLevels(findedPlato.tip_codigo, tp)
        tt.push(findedPlato.tip_codigo)
        arrTP = tt
      } else {
        const types: any[] = await tp
          .filter((e: any) => e.tip_previo == findedPlato.tip_codigo)
          .map((e: any) => e.tip_codigo)
        // setFilterPlateTypes(types)
        arrTP = types
      }

      // CRÍTICO: Procesar dias_bloqueados del primer elemento del grupo
      // El procedimiento amd_getEstructuraByContrato devuelve dias_bloqueados como string (ej: "1,2,3" o " 2, 4, 6, 1")
      let mapBlockedD: any[] = []
      
      // Primero intentar obtener dias_bloqueados del primer elemento del grupo (de amd_getDatosByContrato)
      let diasBloqueadosStr = e[0]?.dias_bloqueados
      
      // Si no está en el primer elemento, buscar en el mapa de amd_getEstructuraByContrato
      if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && mapaDiasBloqueados.size > 0) {
        const idEstructuraContrato = e[0]?.id_estructura_contrato
        const codEstructura = e[0]?.cod_estructura
        const idEstructura = e[0]?.id_estructura
        const id = e[0]?.id // También puede venir como "id" directamente
        const contratoOrigen = e[0]?.contratoOrigen || e[0]?.id_contrato
        
        const nombreEstructura = e[0]?.estructura || e[0]?.nombre || 'sin_nombre'
        
        // Normalizar contratoOrigen a número para comparación
        const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
        
        // Intentar múltiples claves (en orden de prioridad)
        // 1. Por id_estructura_contrato (campo principal en amd_getDatosByContrato)
        if (idEstructuraContrato && contratoOrigenNum) {
          const key1 = `${idEstructuraContrato}-${contratoOrigenNum}`
          diasBloqueadosStr = mapaDiasBloqueados.get(key1) || diasBloqueadosStr
        }
        // 2. Por id (campo en amd_getEstructuraByContrato que corresponde a id_estructura_contrato)
        if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && id && contratoOrigenNum) {
          const keyId = `${id}-${contratoOrigenNum}`
          diasBloqueadosStr = mapaDiasBloqueados.get(keyId) || diasBloqueadosStr
        }
        // 3. Por cod_estructura
        if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && codEstructura && contratoOrigenNum) {
          const key2 = `${codEstructura}-${contratoOrigenNum}`
          diasBloqueadosStr = mapaDiasBloqueados.get(key2) || diasBloqueadosStr
        }
        // 4. Por id_estructura
        if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && idEstructura && contratoOrigenNum) {
          const key3 = `${idEstructura}-${contratoOrigenNum}`
          diasBloqueadosStr = mapaDiasBloqueados.get(key3) || diasBloqueadosStr
        }
        
        // 5. Búsqueda alternativa: buscar sin contrato (por si el contrato no coincide)
        // Esto es importante porque el mapa puede tener datos de un contrato diferente
        if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && idEstructuraContrato) {
          // Buscar todas las claves que empiecen con el id_estructura_contrato
          const clavesCoincidentes = Array.from(mapaDiasBloqueados.keys()).filter((k: string) => 
            k.startsWith(`${idEstructuraContrato}-`)
          )
          if (clavesCoincidentes.length > 0) {
            diasBloqueadosStr = mapaDiasBloqueados.get(clavesCoincidentes[0]) || diasBloqueadosStr
          }
        }
        
        // 6. Búsqueda alternativa por id sin contrato
        if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && id) {
          const clavesCoincidentes = Array.from(mapaDiasBloqueados.keys()).filter((k: string) => 
            k.startsWith(`${id}-`)
          )
          if (clavesCoincidentes.length > 0) {
            diasBloqueadosStr = mapaDiasBloqueados.get(clavesCoincidentes[0]) || diasBloqueadosStr
          }
        }
        
        // 7. Búsqueda alternativa por cod_estructura sin contrato
        if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && codEstructura) {
          const clavesCoincidentes = Array.from(mapaDiasBloqueados.keys()).filter((k: string) => 
            k.startsWith(`${codEstructura}-`)
          )
          if (clavesCoincidentes.length > 0) {
            diasBloqueadosStr = mapaDiasBloqueados.get(clavesCoincidentes[0]) || diasBloqueadosStr
          }
        }
        
        // 8. Búsqueda alternativa por id_estructura sin contrato
        if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && idEstructura) {
          const clavesCoincidentes = Array.from(mapaDiasBloqueados.keys()).filter((k: string) => 
            k.startsWith(`${idEstructura}-`)
          )
          if (clavesCoincidentes.length > 0) {
            diasBloqueadosStr = mapaDiasBloqueados.get(clavesCoincidentes[0]) || diasBloqueadosStr
          }
        }
      }
      
      // Procesar dias_bloqueados si existe
      if (diasBloqueadosStr && diasBloqueadosStr !== '' && diasBloqueadosStr.trim() !== '') {
        // Convertir el string de dias_bloqueados a array de números (puede tener espacios, ej: " 2, 4, 6, 1")
        mapBlockedD = diasBloqueadosStr.toString()
          .split(',')
          .map((d: string) => parseInt(d.trim()))
          .filter((d: number) => !isNaN(d) && d > 0)
      } else {
        // Si no hay dias_bloqueados, intentar usar mapBlockedDays como fallback (por si viene dia_bloqueo)
        mapBlockedD = mapBlockedDays(e)
      }
      
      const blockedDays = mapBlockedD.length
        ? unique(mapBlockedD)
            .map((d: any) => mapDaysStr(d))
            .join(',')
        : 'No aplica'
      // Determinar el ID del contrato para esta estructura
      // Usar directamente el contratoOrigen o id_contrato del registro
      const contratoOrigen = e[0].contratoOrigen
      const idContratoItem = e[0].id_contrato
      let contratoId: any = null
      
      // Normalizar IDs para comparación
      const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
      const idContratoNum = idContratoItem ? (typeof idContratoItem === 'string' ? parseInt(idContratoItem) : idContratoItem) : null
      
      // SIMPLIFICADO: Usar directamente el contratoOrigen o id_contrato si está en la lista permitida
      // Si no está, BLOQUEAR esta estructura (no pertenece a contratos seleccionados)
      if (contratoOrigenNum && contratosPermitidos.includes(contratoOrigenNum)) {
        contratoId = contratoOrigenNum
      } else if (idContratoNum && contratosPermitidos.includes(idContratoNum)) {
        contratoId = idContratoNum
      } else {
        // Si el contratoOrigen o id_contrato NO está en la lista permitida, BLOQUEAR esta estructura
        // NO agregar esta estructura a la tabla - retornar null para filtrar después
        return null
      }
      
      const itemStep2: contStep2 = {
        load: isLoad,
        idEstRel: isLoad
          ? e[0].id_estructura_contrato
          : e[0].id_est_rel && typeof e[0].id_est_rel === 'number'
          ? e[0].id_est_rel
          : 0, // probar validacion
        contrato: contratoId,
        fatherStructure: e[0].tipo_estructura,
        idFatherStructure: e[0].id_grupo_estructura,
        tolerance: e[0].NombreIntolerancia,
        idTolerance: e[0].id_intolerancia,
        allergens: e[0].NombreAlergeno,
        idAllergens: e[0].id_alergeno,
        structure: e[0].estructura,
        idStructure: e[0].id_estructura_hijo, //  isLoad ? 0 : e[0].id_estructura_hijo, // probar validacion
        idStru: e[0].id_estructura,
        dietaryCategory: e[0].car_nombre,
        dietaryCategoryAll: e[0].car_nombre_jer_estructura, // e[0].car_nombre_jer,
        idDietaryCategory: e[0].id_categoria_dietetica_estructura, // e[0].id_categoria_dietetica,
        id: key,
        data: {
          blockedDays: unique(mapBlockedD),
        },
        blockedDays: mapBlockedD.length
          ? unique(mapBlockedD)
              .map((d: any) => mapDaysStr(d))
              .join(',')
          : 'No aplica',
        idBlockedDays: unique(mapBlockedD),
        idPlateType: e[0].tipo_plato,
        plateType: e[0].nombre_tipo_plato,
        plateTypes: arrTP,
        order: e[0].orden,
      }
      
      return itemStep2
    }))
    
    // Filtrar nulls y agregar a dataStep2
    const itemsValidos = items.filter((item: any) => item !== null)
    dataStep2.push(...itemsValidos)
    
    // OPTIMIZADO: Ejecutar inmediatamente después de que se completen las promesas
    // Usar requestAnimationFrame para evitar bloquear la UI durante el procesamiento pesado
    requestAnimationFrame(() => {
      // IMPORTANTE: Eliminar duplicados antes de ordenar
      // Las estructuras pueden estar duplicadas si tienen el mismo id_estructura_contrato y contrato
      // Usar un Map para eliminar duplicados basándose en id_estructura_contrato-contrato-order
      const estructurasUnicasMap = new Map<string, any>()
      
      // CRÍTICO: Eliminar duplicados usando una clave única más robusta
      // La clave debe incluir: contrato + id_estructura_contrato (idEstRel) + order + nombre estructura
      // IMPORTANTE: Usar idEstRel como identificador principal ya que es único por contrato
      dataStep2.forEach((item: any) => {
        // Usar idEstRel como identificador principal (es el id_estructura_contrato)
        // Si no está disponible, usar idStructure o idStru
        const idEstructuraContrato = item.idEstRel || item.idStructure || item.idStru || 0
        const nombreEstructura = (item.structure || '').trim().toLowerCase()
        const order = item.order || 0
        const contrato = item.contrato || 0
        const idFatherStructure = item.idFatherStructure || 0
        
        // Clave única: contrato-idEstructuraContrato-order-idFatherStructure-nombreEstructura
        // CRÍTICO: Incluir contrato PRIMERO para asegurar que estructuras del mismo contrato se agrupen correctamente
        // Si idEstRel está disponible, usarlo como identificador principal (es único por contrato)
        const keyUnico = idEstructuraContrato > 0 
          ? `${contrato}-${idEstructuraContrato}-${order}`
          : `${contrato}-${idEstructuraContrato}-${order}-${idFatherStructure}-${nombreEstructura}`
        
        // Solo agregar si no existe ya (evita duplicados)
        if (!estructurasUnicasMap.has(keyUnico)) {
          estructurasUnicasMap.set(keyUnico, item)
        }
      })
      
      // Convertir Map a array
      const estructurasUnicas = Array.from(estructurasUnicasMap.values())
      
      // Obtener el orden de los contratos seleccionados al inicio para mantener ese orden
      const contratosSeleccionadosOrden = obtenerContratosSeleccionadosAlInicio(datosContrato, contrato)
      const contratosSeleccionadosOrdenNormalizados = contratosSeleccionadosOrden.map((id: any) => {
        return typeof id === 'string' ? parseInt(id) : id
      }).filter((id: any) => id && !isNaN(id))
      
      // Crear un mapa para obtener el índice de orden de cada contrato
      const ordenContratoMap = new Map<number, number>()
      contratosSeleccionadosOrdenNormalizados.forEach((contratoId: any, index: number) => {
        ordenContratoMap.set(contratoId, index)
      })
      
      // Ordenar manteniendo el orden de los contratos seleccionados al inicio
      estructurasUnicas.sort((a: any, b: any) => {
        const ordenA = ordenContratoMap.get(a.contrato) ?? 9999 // Si no está en la lista, al final
        const ordenB = ordenContratoMap.get(b.contrato) ?? 9999
        
        // Primero ordenar por el orden de selección de contratos
        if (ordenA !== ordenB) {
          return ordenA - ordenB
        }
        // Si el contrato es el mismo, ordenar por order
        return a.order - b.order
      })
      
      const orderArray: any = estructurasUnicas
      
      // VALIDACIÓN FINAL CRÍTICA: Filtrar orderArray antes de establecerlo
      const orderArrayValidado = validarYFiltrarDataRow2(orderArray, contrato, datosContrato, modoEdicion)
      
      setDataRow2(orderArrayValidado)
    })

    // step 6 - Procesar estructuras fijas SOLO las seleccionadas en el modal
    // IMPORTANTE: Usar SOLO contratos explícitamente en localStorage (NO usar obtenerContratosSeleccionadosAlInicio)
    
    // Obtener SOLO contratos explícitamente en localStorage
    let contratoOrigenExplicitoEstructurasFijas: any = null
    let contratosDestinoMultipleExplicitoEstructurasFijas: any[] = []
    
    try {
      const contratoOrigenStrEstructurasFijas = localStorage.getItem('contratoOrigenSeleccionado')
      if (contratoOrigenStrEstructurasFijas && contratoOrigenStrEstructurasFijas !== '' && contratoOrigenStrEstructurasFijas !== 'null' && contratoOrigenStrEstructurasFijas !== 'undefined') {
        const parsed = parseInt(contratoOrigenStrEstructurasFijas)
        if (!isNaN(parsed) && parsed > 0) {
          contratoOrigenExplicitoEstructurasFijas = parsed
        }
      }
    } catch (e) {}
    
    try {
      // CRÍTICO: Verificar que el checkbox homologada2 esté marcado antes de usar templateHomologada2
      const homologada2StrEstructurasFijas = localStorage.getItem('homologada2')
      const homologada2MarcadoEstructurasFijas = homologada2StrEstructurasFijas === 'true'
      
      const templateHomologada2StrEstructurasFijas = localStorage.getItem('templateHomologada2')
      
      // Solo usar templateHomologada2 si el checkbox está marcado
      if (homologada2MarcadoEstructurasFijas && templateHomologada2StrEstructurasFijas && templateHomologada2StrEstructurasFijas !== '[]' && templateHomologada2StrEstructurasFijas !== '' && templateHomologada2StrEstructurasFijas !== 'null' && templateHomologada2StrEstructurasFijas !== 'undefined') {
        const templateHomologada2 = JSON.parse(templateHomologada2StrEstructurasFijas)
        if (Array.isArray(templateHomologada2) && templateHomologada2.length > 0) {
          contratosDestinoMultipleExplicitoEstructurasFijas = templateHomologada2
            .map((item: any) => typeof item === 'object' && item !== null ? (item.value || item) : item)
            .map((id: any) => typeof id === 'string' ? parseInt(id) : id)
            .filter((id: any) => id && !isNaN(id) && id > 0)
        }
      } else if (!homologada2MarcadoEstructurasFijas) {
        contratosDestinoMultipleExplicitoEstructurasFijas = []
      }
    } catch (e) {}
    
    const contratosPermitidosExplicitosEstructurasFijas = [contratoOrigenExplicitoEstructurasFijas, ...contratosDestinoMultipleExplicitoEstructurasFijas].filter((id: any) => id && !isNaN(id))
    const contratosParaEstructurasFijasNormalizados = Array.from(new Set(contratosPermitidosExplicitosEstructurasFijas))
    
    
    // FILTRAR estructuras fijas: SOLO incluir las que fueron seleccionadas en el modal
    // IMPORTANTE: En modo edición, NO filtrar - usar TODAS las estructuras fijas cargadas
    let estructurasFijasFiltradas: any[] = []
    
    if (modoEdicion) {
      // Modo edición: usar TODAS las estructuras fijas sin filtrar
      estructurasFijasFiltradas = todasEstructurasFijas
    } else {
      // Modo creación: filtrar por las seleccionadas en el modal
      try {
        // Leer estructuras fijas del contrato base
        let estructurasFijasSeleccionadas: any[] = []
        const estructurasFijasSeleccionadasStr = localStorage.getItem('estructurasFijasSeleccionadas')
        if (estructurasFijasSeleccionadasStr && estructurasFijasSeleccionadasStr !== '[]' && estructurasFijasSeleccionadasStr !== '') {
          estructurasFijasSeleccionadas = JSON.parse(estructurasFijasSeleccionadasStr)
          if (!Array.isArray(estructurasFijasSeleccionadas)) {
            estructurasFijasSeleccionadas = []
          }
        }
        
        // Leer estructuras fijas de contratos múltiples
        let estructurasFijasMultiples: any[] = []
        const estructurasFijasMultiplesStr = localStorage.getItem('estructurasFijasMultiples')
        if (estructurasFijasMultiplesStr && estructurasFijasMultiplesStr !== '[]' && estructurasFijasMultiplesStr !== '') {
          estructurasFijasMultiples = JSON.parse(estructurasFijasMultiplesStr)
          if (!Array.isArray(estructurasFijasMultiples)) {
            estructurasFijasMultiples = []
          }
        }
        
        // Combinar ambas listas
        const todasEstructurasFijasSeleccionadas = [...estructurasFijasSeleccionadas, ...estructurasFijasMultiples]
        
        // REPLICAR EXACTAMENTE LA LÓGICA DE ESTRUCTURAS NORMALES
        // Si no hay estructuras fijas seleccionadas, NO cargar ninguna
        if (todasEstructurasFijasSeleccionadas.length === 0) {
          estructurasFijasFiltradas = []
        } else {
        // Crear un Set de claves "contratoId-id_receta" para búsqueda rápida
        // CRÍTICO: id_receta es el identificador principal para estructuras fijas
        const estructurasFijasSeleccionadasSet = new Set<string>()
        let estructurasSinDatos = 0
        // Agrupar estructuras por contrato para debugging
        const estructurasPorContrato = todasEstructurasFijasSeleccionadas.reduce((acc: any, ef: any) => {
          const contratoId = ef.contratoId?.toString() || 'sin-contrato'
          if (!acc[contratoId]) acc[contratoId] = []
          acc[contratoId].push(ef)
          return acc
        }, {})
        
        todasEstructurasFijasSeleccionadas.forEach((ef: any) => {
          const contratoId = ef.contratoId?.toString() || ''
          const idReceta = ef.id_receta?.toString() || ''
          if (contratoId && idReceta) {
            const key = `${contratoId}-${idReceta}`
            estructurasFijasSeleccionadasSet.add(key)
          } else {
            estructurasSinDatos++
          }
        })
        
        const todasLasClaves = Array.from(estructurasFijasSeleccionadasSet)
        
        // Agrupar claves por contrato
        const clavesPorContrato = todasLasClaves.reduce((acc: any, key: string) => {
          const [contratoId] = key.split('-')
          if (!acc[contratoId]) acc[contratoId] = []
          acc[contratoId].push(key)
          return acc
        }, {})
        
        // Filtrar todasEstructurasFijas para incluir SOLO las que están en el Set
        // MISMA LÓGICA que estructuras normales: solo incluir las seleccionadas
        let contadorFiltradas = 0
        let contadorDescartadas = 0
        let contadorSinDatos = 0
        let contadorNoPermitido = 0
        
        estructurasFijasFiltradas = todasEstructurasFijas.filter((ef: any) => {
          // CRÍTICO: Usar SOLO contratoOrigen (no id_contrato como fallback)
          // contratoOrigen es el contrato del cual se está copiando (asignado en línea 554)
          // id_contrato es el contrato original de la BD y puede ser diferente
          const contratoOrigen = ef.contratoOrigen || ''
          const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
          const idReceta = ef.id_receta?.toString() || ''
          
          // Si no tiene contratoOrigen o id_receta, descartar
          if (!contratoOrigenNum || !idReceta) {
            contadorSinDatos++
            return false
          }
          
          // Verificar que el contrato esté permitido
          if (!contratosPermitidosExplicitosEstructurasFijas.includes(contratoOrigenNum)) {
            contadorNoPermitido++
            return false
          }
          
          // Verificar si está en el Set de seleccionadas
          const key = `${contratoOrigenNum}-${idReceta}`
          const estaEnSet = estructurasFijasSeleccionadasSet.has(key)
          
          if (estaEnSet) {
            contadorFiltradas++
            return true
          } else {
            contadorDescartadas++
            return false
          }
        })
        if (estructurasFijasFiltradas.length > 0) {
          // Agrupar por contrato para ver cuántas hay de cada uno
          const porContrato = estructurasFijasFiltradas.reduce((acc: any, ef: any) => {
            const contrato = ef.contratoOrigen || ef.id_contrato
            if (!acc[contrato]) acc[contrato] = []
            acc[contrato].push({ id_receta: ef.id_receta, nombre: ef.rec_nombre })
            return acc
          }, {})
        }
      }
      } catch (e: any) {
        estructurasFijasFiltradas = []
      }
    }
    
    const estructurasFijasPorContrato = contratosPermitidosExplicitosEstructurasFijas.map((contratoId: any) => {
      const count = estructurasFijasFiltradas.filter((e: any) => {
        const contratoOrigen = e.contratoOrigen
        const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
        return contratoOrigenNum === contratoId
      }).length
      return { contrato: contratoId, estructurasFijas: count }
    })
    
    const rec: contStep6[] = []
    
    // Procesar todas las estructuras fijas filtradas (solo contratos seleccionados al inicio)
      estructurasFijasFiltradas.forEach((e: any, key: number) => {
        // CRÍTICO: Usar contratoOrigen (ya viene del SP con el valor correcto asignado en línea 554)
        // contratoOrigen es el contrato del cual se está copiando la estructura
        // Si no tiene contratoOrigen, usar id_contrato como fallback (aunque debería tenerlo siempre)
        const contratoOrigen = e.contratoOrigen || e.id_contrato || null
        
        rec.push({
        id: key,
        data: e,
          recipe: e.rec_nombre,
          idRecipe: e.id_receta,
          fatherStructure4: e.nombreGrupoEstructura,
          structure: e.nombre_estructura,
          nombre_estructura: e.nombre_estructura,
          idFatherStructure4: e.id_grupo_estructura,
        load: e.contratoOrigen ? true : isLoad, // Si tiene contratoOrigen, es de múltiples contratos
        idEstRel: isLoad ? e.id : e.id_est_rel ? e.id_est_rel : 0,
          id_estructura: e.id_estructura,
          contrato: contratoOrigen, // Usar contratoOrigen (asignado correctamente en línea 554)
        })
      })
    
    // Guardar todas las estructuras fijas sin filtrar
    setTodasLasEstructurasFijasSinFiltrar(rec)
    setDataRow6(rec)
    
    // step 3 - Cargar recetas fijas SOLO de los contratos seleccionados explícitamente
    // (Homologada Origen + Homologada Destino Multiple)
    // IMPORTANTE: NO usar obtenerContratosSeleccionadosAlInicio, usar SOLO localStorage
    let formContract3Map: contStep3[] = []
    let formContract3: contStep3[] = []
    
    // CRÍTICO: Obtener SOLO contratos explícitamente en localStorage (NO usar obtenerContratosSeleccionadosAlInicio)
    let contratoOrigenExplicitoRecetas: any = null
    let contratosDestinoMultipleExplicitoRecetas: any[] = []
    
    try {
      const contratoOrigenStrRecetas = localStorage.getItem('contratoOrigenSeleccionado')
      if (contratoOrigenStrRecetas && contratoOrigenStrRecetas !== '' && contratoOrigenStrRecetas !== 'null' && contratoOrigenStrRecetas !== 'undefined') {
        const parsed = parseInt(contratoOrigenStrRecetas)
        if (!isNaN(parsed) && parsed > 0) {
          contratoOrigenExplicitoRecetas = parsed
        }
      }
    } catch (e) {}
    
    try {
      // CRÍTICO: Verificar que el checkbox homologada2 esté marcado antes de usar templateHomologada2
      const homologada2StrRecetas = localStorage.getItem('homologada2')
      const homologada2MarcadoRecetas = homologada2StrRecetas === 'true'
      
      const templateHomologada2StrRecetas = localStorage.getItem('templateHomologada2')
      
      // Solo usar templateHomologada2 si el checkbox está marcado
      if (homologada2MarcadoRecetas && templateHomologada2StrRecetas && templateHomologada2StrRecetas !== '[]' && templateHomologada2StrRecetas !== '' && templateHomologada2StrRecetas !== 'null' && templateHomologada2StrRecetas !== 'undefined') {
        const templateHomologada2 = JSON.parse(templateHomologada2StrRecetas)
        if (Array.isArray(templateHomologada2) && templateHomologada2.length > 0) {
          contratosDestinoMultipleExplicitoRecetas = templateHomologada2
            .map((item: any) => typeof item === 'object' && item !== null ? (item.value || item) : item)
            .map((id: any) => typeof id === 'string' ? parseInt(id) : id)
            .filter((id: any) => id && !isNaN(id) && id > 0)
        }
      } else if (!homologada2MarcadoRecetas) {
        // Si el checkbox NO está marcado, limpiar templateHomologada2
        localStorage.removeItem('templateHomologada2')
        contratosDestinoMultipleExplicitoRecetas = []
      }
    } catch (e) {}
    
    const contratosPermitidosExplicitosRecetas = [contratoOrigenExplicitoRecetas, ...contratosDestinoMultipleExplicitoRecetas].filter((id: any) => id && !isNaN(id))
    
    // CRÍTICO: En modo edición, usar SOLO el ID del contrato que se está editando
    // NO usar los contratos "padre" porque el contrato editado ya tiene sus propias recetas fijas
    let contratosUnicosRecetasFijas = Array.from(new Set(contratosPermitidosExplicitosRecetas))
    
    if (modoEdicion) {
      // Modo edición: usar SOLO el ID del contrato que se está editando
      contratosUnicosRecetasFijas = [contratoIdNum]
    } else if (contratosUnicosRecetasFijas.length === 0) {
      // Modo creación sin contratos seleccionados: no cargar nada
    }
    
    // Obtener contratos de Homologada Destino Multiple (para referencia)
    let contratosDestinoMultiple: any[] = contratosDestinoMultipleExplicitoRecetas
    
    let todasRecetasFijas: any[] = []
    
    if (contratosUnicosRecetasFijas.length > 0) {
      const promesasRecetasFijas = contratosUnicosRecetasFijas.map(async (contratoId: any) => {
        try {
          const contratoIdNum = typeof contratoId === 'string' ? parseInt(contratoId) : contratoId
          
          // VALIDACIÓN CRÍTICA: Verificar que el contrato esté realmente en la lista permitida
          // IMPORTANTE: En modo edición, NO validar contra localStorage (está vacío)
          if (!modoEdicion && !contratosPermitidosExplicitosRecetas.includes(contratoIdNum)) {
            return []
          }
          
          const esDestinoMultiple = contratosDestinoMultiple.includes(contratoIdNum)
          const dataRecetaFijaMultiple: any = await callSP('amd_getRecetaFijaByContrato', [
            {text: 'contrato', value: contratoIdNum ? contratoIdNum.toString() : '0'},
          ])
          
          if (dataRecetaFijaMultiple?.data?.status === '200' && Array.isArray(dataRecetaFijaMultiple.data.result)) {
            const recetasConOrigen = dataRecetaFijaMultiple.data.result.map((e: any) => ({
              ...e,
              contratoOrigen: contratoIdNum
            }))
            return recetasConOrigen
          } else {
            return []
          }
        } catch (e: any) {
          return []
        }
      })
      
      const recetasFijasMultiples = await Promise.all(promesasRecetasFijas)
      todasRecetasFijas = recetasFijasMultiples.flat()
    }
    
    // FILTRAR recetas fijas: SOLO incluir las de contratos seleccionados explícitamente
    // IMPORTANTE: En modo edición, NO filtrar - usar TODAS las recetas fijas cargadas
    let recetasFijasFiltradas: any[] = []
    
    if (modoEdicion) {
      // Modo edición: usar TODAS las recetas fijas sin filtrar
      recetasFijasFiltradas = todasRecetasFijas
    } else {
      // Modo creación: filtrar por contratos seleccionados explícitamente
      recetasFijasFiltradas = todasRecetasFijas.filter((rf: any) => {
        const contratoOrigen = rf.contratoOrigen
        const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
        
        const estaPermitida = contratoOrigenNum && contratosPermitidosExplicitosRecetas.includes(contratoOrigenNum)
        
        if (!estaPermitida && contratoOrigenNum) {
        }
        
        return estaPermitida
      })
    }
    
    
    // Actualizar el estado con las recetas fijas filtradas
    setRecetaFija(recetasFijasFiltradas)

    // Procesar todas las recetas fijas filtradas (solo contratos seleccionados)
    // const groupRecFija = Object.values(groupBy(recetasFijasFiltradas, 'id_receta', 'id_estructura_contrato'))
    const groupRecFija: any[] = groupByMultiple(recetasFijasFiltradas, (item: any) => {
      return [item.id_receta, item.id_estructura_contrato, item.ciclo]
    })
    groupRecFija.forEach((e: any, key: number) => {
      let diasClico: any = unique(e.map((i: any) => i.dia_ciclo)).sort((a: any, b: any) => a - b)
      let mapDays: any = diasClico.map((d: any) => mapDaysStr(d))
      formContract3Map.push({
        cycleWeek: unique(e.map((i: any) => i.ciclo)).join(','),
        idCycleWeek: unique(e.map((i: any) => i.ciclo)),
        fatherStructure2: e[0].estructura,
        id: key,
        data: e,
        idDelete: key,
        mainIngredients: e[0].Nombretipoingprincipal,
        idMainIngredients: e[0].id_ingrediente_principal,
        recipe: e[0].receta,
        idRecipe: e[0].id_receta,
        diaReceta: mapDays.join(','),
        idDiaReceta: diasClico,
        intercalaryWeek: e[0].intercalado == 2 ? 'Fijo' : 'Rotativa',
        idIntercalaryWeek: e[0].intercalado.toString(),
        dietaryCategory2: e[0].car_nombre_jer,
        idDietaryCategory2: e[0].categoria_dietetica.toString(),
        load: isLoad,
        idRecetaFija: e[0].idRecetaFija,
      })
    })

    const groupRecFijaDias: any[] = groupByMultiple(formContract3Map, (item: any) => {
      return [item.idRecipe, item.fatherStructure2, item.diaReceta]
    })

    groupRecFijaDias.forEach((e: any, key: number) => {
      let ciclos: any = unique(e.map((i: any) => i.idCycleWeek[0])).sort((a: any, b: any) => a - b)
      let idRecetaFijaDayWeek: any = e.map((i: any) => i.idRecetaFija)
      
      formContract3.push({
        ...e[0],
        cycleWeek: ciclos.join(','),
        idCycleWeek: ciclos,
        idRecetaFijaDayWeek: idRecetaFijaDayWeek.join(",")
      })
    })
    
    // Guardar todas las recetas fijas sin filtrar (para referencia)
    setTodasLasRecetasFijasSinFiltrar(formContract3)
    
    // CRÍTICO: Aplicar filtro por nombres de estructuras seleccionadas INMEDIATAMENTE
    // El campo fatherStructure2 (que es "estructura") debe coincidir con los nombres seleccionados
    const nombresEstructurasSeleccionadasRecetas = new Set<string>()
    
    try {
      // 1. Obtener nombres de estructuras del contrato origen
      const estructurasConNombresStrRecetas = localStorage.getItem('estructurasSeleccionadasConNombres')
      if (estructurasConNombresStrRecetas && estructurasConNombresStrRecetas !== '[]' && estructurasConNombresStrRecetas !== '') {
        const estructurasConNombresRecetas = JSON.parse(estructurasConNombresStrRecetas)
        if (Array.isArray(estructurasConNombresRecetas)) {
          estructurasConNombresRecetas.forEach((est: any) => {
            if (est.nombre) {
              nombresEstructurasSeleccionadasRecetas.add(est.nombre.toLowerCase().trim())
            }
          })
        }
      }

      // 2. Obtener nombres de estructuras múltiples seleccionadas
      const estructurasMultiplesStrRecetas = localStorage.getItem('estructurasMultiples')
      if (estructurasMultiplesStrRecetas && estructurasMultiplesStrRecetas !== '[]' && estructurasMultiplesStrRecetas !== '') {
        const estructurasMultiplesRecetas = JSON.parse(estructurasMultiplesStrRecetas)
        if (Array.isArray(estructurasMultiplesRecetas)) {
          estructurasMultiplesRecetas.forEach((est: any) => {
            const nombreEst = (est.ess_nombre || est.nombre || est.estructura || '').toLowerCase().trim()
            if (nombreEst) {
              nombresEstructurasSeleccionadasRecetas.add(nombreEst)
            }
          })
        }
      }
    } catch (e) {
    }
    
    // Aplicar filtro si hay estructuras seleccionadas
    let recetasFiltradas = formContract3
    if (nombresEstructurasSeleccionadasRecetas.size > 0 && !modoEdicion) {
      recetasFiltradas = formContract3.filter((receta: any) => {
        const nombreEstructuraReceta = receta.fatherStructure2 ? receta.fatherStructure2.toLowerCase().trim() : ''
        const estaSeleccionada = nombreEstructuraReceta && nombresEstructurasSeleccionadasRecetas.has(nombreEstructuraReceta)
        
        return estaSeleccionada
      })
    }
    
    setDataRow3(recetasFiltradas)

    // step 5 - Frecuencia Ingredientes
    // IMPORTANTE: Usar SOLO datos de contratos seleccionados al inicio
    // (Homologada Origen + Homologada Destino Multiple)
    // CRÍTICO: Usar SOLO contratos explícitamente en localStorage (NO usar obtenerContratosSeleccionadosAlInicio)
    let contratoOrigenExplicitoFrecuencia: any = null
    let contratosDestinoMultipleExplicitoFrecuencia: any[] = []
    
    try {
      const contratoOrigenStrFrecuencia = localStorage.getItem('contratoOrigenSeleccionado')
      if (contratoOrigenStrFrecuencia && contratoOrigenStrFrecuencia !== '' && contratoOrigenStrFrecuencia !== 'null' && contratoOrigenStrFrecuencia !== 'undefined') {
        const parsed = parseInt(contratoOrigenStrFrecuencia)
        if (!isNaN(parsed) && parsed > 0) {
          contratoOrigenExplicitoFrecuencia = parsed
        }
      }
    } catch (e) {}
    
    try {
      // CRÍTICO: Verificar que el checkbox homologada2 esté marcado antes de usar templateHomologada2
      const homologada2StrFrecuencia = localStorage.getItem('homologada2')
      const homologada2MarcadoFrecuencia = homologada2StrFrecuencia === 'true'
      
      const templateHomologada2StrFrecuencia = localStorage.getItem('templateHomologada2')
      
      // Solo usar templateHomologada2 si el checkbox está marcado
      if (homologada2MarcadoFrecuencia && templateHomologada2StrFrecuencia && templateHomologada2StrFrecuencia !== '[]' && templateHomologada2StrFrecuencia !== '' && templateHomologada2StrFrecuencia !== 'null' && templateHomologada2StrFrecuencia !== 'undefined') {
        const templateHomologada2 = JSON.parse(templateHomologada2StrFrecuencia)
        if (Array.isArray(templateHomologada2) && templateHomologada2.length > 0) {
          contratosDestinoMultipleExplicitoFrecuencia = templateHomologada2
            .map((item: any) => typeof item === 'object' && item !== null ? (item.value || item) : item)
            .map((id: any) => typeof id === 'string' ? parseInt(id) : id)
            .filter((id: any) => id && !isNaN(id) && id > 0)
        }
      } else if (!homologada2MarcadoFrecuencia) {
        contratosDestinoMultipleExplicitoFrecuencia = []
      }
    } catch (e) {}
    
    const contratosPermitidosExplicitosFrecuencia = [contratoOrigenExplicitoFrecuencia, ...contratosDestinoMultipleExplicitoFrecuencia].filter((id: any) => id && !isNaN(id))
    let contratosParaFrecuenciaIngredientesNormalizados = Array.from(new Set(contratosPermitidosExplicitosFrecuencia))
    
    // CRÍTICO: En modo edición, usar SOLO el ID del contrato que se está editando
    // NO usar los contratos "padre" porque el contrato editado ya tiene sus propios datos
    if (modoEdicion) {
      // Modo edición: usar SOLO el ID del contrato que se está editando
      contratosParaFrecuenciaIngredientesNormalizados = [contratoIdNum]
    } else if (contratosParaFrecuenciaIngredientesNormalizados.length === 0) {
      // Modo creación sin contratos seleccionados: no cargar nada
    }
    
    // Obtener estructuras seleccionadas del contrato base y de los contratos múltiples
    // MISMA LÓGICA que para el contrato base: leer directamente de localStorage
    const estructurasSeleccionadasStrFrecuencia = localStorage.getItem('estructurasSeleccionadas')
    const estructurasSeleccionadasIdsFrecuencia = estructurasSeleccionadasStrFrecuencia ? JSON.parse(estructurasSeleccionadasStrFrecuencia) : []
    
    // MISMA LÓGICA que para el contrato base: leer estructurasMultiples directamente de localStorage
    const estructurasMultiplesStrFrecuencia = localStorage.getItem('estructurasMultiples')
    const estructurasMultiplesFrecuencia = estructurasMultiplesStrFrecuencia ? JSON.parse(estructurasMultiplesStrFrecuencia) : []
    
    // CRÍTICO: NO incluir datos del contrato base si ya están en datosContratosMultiples
    // El contrato base ya fue cargado en datosContratosMultiples si está seleccionado
    // Incluir datosBaseFiltrados causaría duplicación de frecuencias
    
    // Verificar si el contrato base está en la lista de seleccionados
    const contratoBaseIdNum = contrato.id ? (typeof contrato.id === 'string' ? parseInt(contrato.id) : contrato.id) : null
    const contratoBaseEstaEnSeleccionados = contratoBaseIdNum && contratosParaFrecuenciaIngredientesNormalizados.includes(contratoBaseIdNum)
    
    // Si el contrato base está seleccionado, sus datos YA están en datosContratosMultiples
    // Solo usar datosBaseFiltrados si el contrato base NO está en la lista de seleccionados
    let datosBaseFiltrados: any[] = []
    if (!contratoBaseEstaEnSeleccionados) {
      // Solo incluir datos del contrato base si NO está en la lista de seleccionados
      datosBaseFiltrados = (dataDatosByContrato.data.result || []).filter((item: any) => {
        const contratoOrigen = item.contratoOrigen || item.id_contrato
        const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
        return contratoOrigenNum && contratosParaFrecuenciaIngredientesNormalizados.includes(contratoOrigenNum)
      })
    }
    
    // Construir mapa de estructuras seleccionadas por contrato (base + múltiples)
    // CRÍTICO: Incluir estructuras de TODOS los contratos donde fueron seleccionadas, no solo del primero
    const estructurasPorContratoMap = new Map<number, Set<number>>()
    
    // 1. Agregar estructuras del contrato base (si tiene estructuras seleccionadas)
    if (contratoBaseEstaEnSeleccionados && Array.isArray(estructurasSeleccionadasIdsFrecuencia) && estructurasSeleccionadasIdsFrecuencia.length > 0) {
      const idsBase = estructurasSeleccionadasIdsFrecuencia
        .map((id: any) => typeof id === 'string' ? parseInt(id) : id)
        .filter((id: any) => id && !isNaN(id))
      if (idsBase.length > 0 && contratoBaseIdNum) {
        estructurasPorContratoMap.set(contratoBaseIdNum, new Set(idsBase))
      }
    } else if (contratoBaseEstaEnSeleccionados) {
      // Si el contrato base está seleccionado pero NO tiene estructuras, crear un Set vacío
      // Esto asegura que se procese el contrato pero sin estructuras
      if (contratoBaseIdNum) {
        estructurasPorContratoMap.set(contratoBaseIdNum, new Set())
      }
    }
    
    // 2. Agregar estructuras NORMALES de contratos múltiples (CRÍTICO: incluir TODOS los contratos con estructuras seleccionadas)
    if (Array.isArray(estructurasMultiplesFrecuencia) && estructurasMultiplesFrecuencia.length > 0) {
      // Agrupar estructuras por contrato para verificar que todos los contratos estén representados
      const estructurasPorContrato = new Map<number, number>()
      estructurasMultiplesFrecuencia.forEach((est: any) => {
        const contratoId = est?.contratoId ? (typeof est.contratoId === 'string' ? parseInt(est.contratoId) : est.contratoId) : null
        if (contratoId) {
          estructurasPorContrato.set(contratoId, (estructurasPorContrato.get(contratoId) || 0) + 1)
        }
      })
      
      estructurasMultiplesFrecuencia.forEach((estructura: any) => {
        const contratoIdNum = estructura?.contratoId ? (typeof estructura.contratoId === 'string' ? parseInt(estructura.contratoId) : estructura.contratoId) : null
        // CRÍTICO: Intentar múltiples campos de ID para asegurar coincidencia
        const estructuraIdNum = estructura?.id ? (typeof estructura.id === 'string' ? parseInt(estructura.id) : estructura.id) : null
        const essCodigoNum = estructura?.ess_codigo ? (typeof estructura.ess_codigo === 'string' ? parseInt(estructura.ess_codigo) : estructura.ess_codigo) : null
        const idEstructuraNum = estructura?.id_estructura ? (typeof estructura.id_estructura === 'string' ? parseInt(estructura.id_estructura) : estructura.id_estructura) : null
        const idEstructuraContratoNum = estructura?.id_estructura_contrato ? (typeof estructura.id_estructura_contrato === 'string' ? parseInt(estructura.id_estructura_contrato) : estructura.id_estructura_contrato) : null
        
        // Usar el primer ID disponible, pero priorizar id_estructura_contrato
        const idFinal = idEstructuraContratoNum || estructuraIdNum || essCodigoNum || idEstructuraNum
        
        if (
          contratoIdNum &&
          idFinal &&
          contratosParaFrecuenciaIngredientesNormalizados.includes(contratoIdNum) &&
          !isNaN(idFinal)
        ) {
          if (!estructurasPorContratoMap.has(contratoIdNum)) {
            estructurasPorContratoMap.set(contratoIdNum, new Set())
          }
          // Agregar TODOS los IDs posibles para asegurar coincidencia
          estructurasPorContratoMap.get(contratoIdNum)!.add(idFinal)
          if (estructuraIdNum && estructuraIdNum !== idFinal) estructurasPorContratoMap.get(contratoIdNum)!.add(estructuraIdNum)
          if (essCodigoNum && essCodigoNum !== idFinal) estructurasPorContratoMap.get(contratoIdNum)!.add(essCodigoNum)
          if (idEstructuraNum && idEstructuraNum !== idFinal) estructurasPorContratoMap.get(contratoIdNum)!.add(idEstructuraNum)
          if (idEstructuraContratoNum && idEstructuraContratoNum !== idFinal) estructurasPorContratoMap.get(contratoIdNum)!.add(idEstructuraContratoNum)
        }
      })
    }
    
    // 2b. CRÍTICO: Agregar estructuras FIJAS de contratos múltiples
    try {
      const estructurasFijasMultiplesStrFrecuencia = localStorage.getItem('estructurasFijasMultiples')
      if (estructurasFijasMultiplesStrFrecuencia && estructurasFijasMultiplesStrFrecuencia !== '[]' && estructurasFijasMultiplesStrFrecuencia !== '') {
        const estructurasFijasMultiplesFrecuencia = JSON.parse(estructurasFijasMultiplesStrFrecuencia)
        if (Array.isArray(estructurasFijasMultiplesFrecuencia) && estructurasFijasMultiplesFrecuencia.length > 0) {
          estructurasFijasMultiplesFrecuencia.forEach((ef: any) => {
            const contratoIdNum = ef?.contratoId ? (typeof ef.contratoId === 'string' ? parseInt(ef.contratoId) : ef.contratoId) : null
            const estructuraIdNum = ef?.id_estructura ? (typeof ef.id_estructura === 'string' ? parseInt(ef.id_estructura) : ef.id_estructura) : null
            
            if (
              contratoIdNum &&
              estructuraIdNum &&
              contratosParaFrecuenciaIngredientesNormalizados.includes(contratoIdNum) &&
              !isNaN(estructuraIdNum)
            ) {
              if (!estructurasPorContratoMap.has(contratoIdNum)) {
                estructurasPorContratoMap.set(contratoIdNum, new Set())
              }
              estructurasPorContratoMap.get(contratoIdNum)!.add(estructuraIdNum)
            }
          })
        }
      }
    } catch (e) {
    }
    
    // 2c. CRÍTICO: Agregar estructuras FIJAS del contrato base
    try {
      const estructurasFijasSeleccionadasStrFrecuencia = localStorage.getItem('estructurasFijasSeleccionadas')
      if (estructurasFijasSeleccionadasStrFrecuencia && estructurasFijasSeleccionadasStrFrecuencia !== '[]' && estructurasFijasSeleccionadasStrFrecuencia !== '') {
        const estructurasFijasSeleccionadasFrecuencia = JSON.parse(estructurasFijasSeleccionadasStrFrecuencia)
        if (Array.isArray(estructurasFijasSeleccionadasFrecuencia) && estructurasFijasSeleccionadasFrecuencia.length > 0 && contratoBaseEstaEnSeleccionados && contratoBaseIdNum) {
          estructurasFijasSeleccionadasFrecuencia.forEach((ef: any) => {
            const estructuraIdNum = ef?.id_estructura ? (typeof ef.id_estructura === 'string' ? parseInt(ef.id_estructura) : ef.id_estructura) : null
            
            if (estructuraIdNum && !isNaN(estructuraIdNum)) {
              if (!estructurasPorContratoMap.has(contratoBaseIdNum)) {
                estructurasPorContratoMap.set(contratoBaseIdNum, new Set())
              }
              estructurasPorContratoMap.get(contratoBaseIdNum)!.add(estructuraIdNum)
            }
          })
        }
      }
    } catch (e) {
    }
    
    // 3. CRÍTICO: Asegurar que TODOS los contratos seleccionados estén en el mapa
    // Incluso si no tienen estructuras seleccionadas, deben estar en el mapa para procesarlos correctamente
    contratosParaFrecuenciaIngredientesNormalizados.forEach((contratoId: number) => {
      if (!estructurasPorContratoMap.has(contratoId)) {
        estructurasPorContratoMap.set(contratoId, new Set())
      }
    })
    
    
    // Obtener datos del procedimiento para TODOS los contratos seleccionados
    // Si existen estructuras seleccionadas para un contrato, filtrar los resultados por esos IDs
    // Si no existen, incluir todos los registros del contrato (mantiene comportamiento previo)
    let todosDatosByContrato: any[] = []
    
    if (contratosParaFrecuenciaIngredientesNormalizados.length > 0) {
      const promesasFrecuencia = contratosParaFrecuenciaIngredientesNormalizados.map(async (contratoId: number) => {
        try {
          const contratoIdNum = typeof contratoId === 'string' ? parseInt(contratoId) : contratoId
          if (!contratoIdNum || isNaN(contratoIdNum)) {
            return []
          }
          
          const datosContratoFrecuencia: any = await callSP('amd_getDatosByContrato', [
            { text: 'contrato', value: contratoIdNum.toString() },
            { text: 'id_minuta', value: '' },
          ])
          
          if (datosContratoFrecuencia?.data?.status === '200' && Array.isArray(datosContratoFrecuencia.data.result)) {
            const idsPermitidosSet = estructurasPorContratoMap.get(contratoIdNum)
            let datosFiltrados = datosContratoFrecuencia.data.result
            
            
            // CRÍTICO: Si hay estructuras seleccionadas para este contrato, SOLO incluir esas estructuras
            // Si NO hay estructuras seleccionadas para este contrato, NO incluir ninguna estructura
            if (idsPermitidosSet && idsPermitidosSet.size > 0) {
              const idsPermitidos = Array.from(idsPermitidosSet)
              
              // CRÍTICO: Primero, obtener todas las estructuras del contrato para mapear IDs
              // Necesitamos llamar a amd_getEstructuraByContrato para obtener el mapeo correcto
              // Mapeo bidireccional: desde cualquier ID hacia id_estructura_contrato
              let estructuraMapDirecto: Map<number, number> = new Map() // Map<cualquier_id, id_estructura_contrato>
              let estructuraMapInverso: Map<number, number[]> = new Map() // Map<id_estructura_contrato, [todos_los_ids_posibles]>
              
              try {
                const dataEstructurasContrato: any = await callSP('amd_getEstructuraByContrato', [
                  { text: 'contrato', value: contratoIdNum.toString() }
                ])
                
                if (dataEstructurasContrato?.data?.status === '200' && Array.isArray(dataEstructurasContrato.data.result)) {
                  dataEstructurasContrato.data.result.forEach((est: any) => {
                    const idEstContrato = est.id_estructura_contrato || est.id || est.idO
                    const idsPosibles = [
                      est.id,
                      est.idO,
                      est.id_estructura,
                      est.ess_codigo,
                      est.cod_estructura,
                      est.id_estructura_contrato,
                      idEstContrato
                    ].filter((id: any) => id && !isNaN(id) && id > 0)
                    
                    if (idEstContrato && idsPosibles.length > 0) {
                      // Mapeo directo: desde cualquier ID hacia id_estructura_contrato
                      idsPosibles.forEach((id: number) => {
                        estructuraMapDirecto.set(id, idEstContrato)
                      })
                      // Mapeo inverso: desde id_estructura_contrato hacia todos los IDs posibles
                      estructuraMapInverso.set(idEstContrato, idsPosibles)
                    }
                  })
                }
              } catch (e) {
                // Error silencioso
              }
              
              // CRÍTICO: Convertir los IDs permitidos (que pueden ser de amd_getEstructuraByContrato) 
              // a id_estructura_contrato usando el mapeo
              const idsPermitidosEstructuraContrato = new Set<number>()
              idsPermitidos.forEach((idPermitido: number) => {
                // Si el ID permitido está en el mapeo directo, usar el id_estructura_contrato correspondiente
                if (estructuraMapDirecto.has(idPermitido)) {
                  const idEstContrato = estructuraMapDirecto.get(idPermitido)!
                  idsPermitidosEstructuraContrato.add(idEstContrato)
                } else {
                  // Si no está en el mapeo, agregarlo directamente (puede ser que ya sea id_estructura_contrato)
                  idsPermitidosEstructuraContrato.add(idPermitido)
                }
              })
              
              // También agregar todos los IDs permitidos originales por si acaso
              idsPermitidos.forEach((id: number) => idsPermitidosEstructuraContrato.add(id))
              
              const datosFiltradosPorEstructura = datosFiltrados.filter((item: any) => {
                const idEstructuraContratoNum = item?.id_estructura_contrato
                  ? (typeof item.id_estructura_contrato === 'string' ? parseInt(item.id_estructura_contrato) : item.id_estructura_contrato)
                  : null
                const idEstructuraNum = item?.id_estructura
                  ? (typeof item.id_estructura === 'string' ? parseInt(item.id_estructura) : item.id_estructura)
                  : null
                const codEstructuraNum = item?.cod_estructura
                  ? (typeof item.cod_estructura === 'string' ? parseInt(item.cod_estructura) : item.cod_estructura)
                  : null
                const essCodigoNum = item?.ess_codigo
                  ? (typeof item.ess_codigo === 'string' ? parseInt(item.ess_codigo) : item.ess_codigo)
                  : null
                
                // CRÍTICO: Comparar con todos los posibles IDs que pueden venir del SP
                // Usar el set expandido que incluye los IDs mapeados
                let estaPermitida = idsPermitidosEstructuraContrato.has(idEstructuraContratoNum) ||
                                   idsPermitidosEstructuraContrato.has(idEstructuraNum) ||
                                   idsPermitidosEstructuraContrato.has(codEstructuraNum) ||
                                   idsPermitidosEstructuraContrato.has(essCodigoNum)
                
                // Si no coincide directamente, buscar en el mapa inverso de estructuras
                if (!estaPermitida && idEstructuraContratoNum && estructuraMapInverso.has(idEstructuraContratoNum)) {
                  const idsRelacionados = estructuraMapInverso.get(idEstructuraContratoNum) || []
                  estaPermitida = idsRelacionados.some((id: number) => idsPermitidosEstructuraContrato.has(id))
                }
                
                return estaPermitida
              })
              
              datosFiltrados = datosFiltradosPorEstructura
            } else {
              // Si NO hay estructuras seleccionadas para este contrato, NO incluir ninguna estructura
              datosFiltrados = []
            }
            
            const datosConContrato = datosFiltrados.map((item: any) => ({
              ...item,
              contratoOrigen: contratoIdNum,
              id_contrato: contratoIdNum
            }))
            return datosConContrato
          } else {
            return []
          }
        } catch (e: any) {
          return []
        }
      })
      
      const resultadosFrecuencia = await Promise.all(promesasFrecuencia)
      todosDatosByContrato = resultadosFrecuencia.flat()
    }
    
    // Respaldo: si no se obtuvo información por contrato, usar datosContratosMultiples como antes
    if (todosDatosByContrato.length === 0) {
      todosDatosByContrato = [...datosContratosMultiples]
      
      if (datosBaseFiltrados.length > 0) {
        todosDatosByContrato = [...todosDatosByContrato, ...datosBaseFiltrados]
      }
    }
    
    // CRÍTICO: Agrupar también por contrato para que cada contrato mantenga su frecuencia separada
    // La frecuencia se calcula correctamente por contrato
    const groupMultiple: any = groupByMultiple(todosDatosByContrato, (item: any) => {
      // Obtener el ID del contrato del registro
      const contratoOrigen = item.contratoOrigen || item.id_contrato
      const contratoId = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
      
      return [
        contratoId, // Incluir contrato en la clave de agrupación (para calcular frecuencia correctamente)
        item.id_estructura_contrato,
        item.id_ingrediente_principal,
        item.comodin,
        item.id_categoria_dietetica,
      ]
    })
    const data4: contStep4[] = []
    const dataComodin = [
      {text: 'Normal', value: '0'},
      {text: '29', value: '29'},
      {text: '30', value: '30'},
      {text: '31', value: '31'},
    ]

    const estructura_editada: any = getSStorage('estructura_editada')

    groupMultiple.forEach((e: any, key: number) => {
      // Obtener el contrato del grupo (todos los items del grupo deben tener el mismo contrato)
      const contratoDelGrupo = e[0]?.contratoOrigen || e[0]?.id_contrato
      const contratoDelGrupoNum = contratoDelGrupo ? (typeof contratoDelGrupo === 'string' ? parseInt(contratoDelGrupo) : contratoDelGrupo) : null
      
      let mapCiclos: any[] = e.map((m: any) => m.ciclo).sort((a: any, b: any) => a - b)
      let ciclos: any[] = mapCiclos.filter((item: any, pos: number) => {
        return mapCiclos.indexOf(item) == pos
      })
      
      // CRÍTICO: La frecuencia debe calcularse SOLO con los datos de este grupo (que ya está filtrado por contrato)
      // Filtrar por dia_bloqueo para evitar duplicados dentro del mismo contrato
      // Esto asegura que cada día bloqueado se cuente solo una vez
        let groupFilter: any[] = []
        e.forEach((item: any) => {
          if (groupFilter.findIndex((i: any) => i.dia_bloqueo != item.dia_bloqueo) === -1) {
            groupFilter.push(item)
          }
        })
      
      // CRÍTICO: La frecuencia es la SUMA de las cantidades de cada estructura
      // Sumar cantidad_frecuencia de todos los registros únicos (filtrados por dia_bloqueo)
      // Esto representa la cantidad total de veces que aparece esa estructura con ese ingrediente
        let qtyFreqGroup: any = groupFilter.reduce(
        (acc: number, cur: any) => (cur.cantidad_frecuencia || 0) + acc,
        0
      )
      
      if (qtyFreqGroup > 0) {
        data4.push({
          load: isLoad,
          frequency: qtyFreqGroup,
          fatherStructure3: e[0].estructura,
          idFatherStructure3: e[0].id_grupo_estructura,
          id: key,
          idDelete: key,
          data: e[0],
          mainIngredients2: e[0].Nombretipoingprincipal,
          idMainIngredients2: e[0].id_ingrediente_principal,
          cycles4: ciclos.join(','),
          idCycles4: ciclos,
          comodin: e[0].comodin === 0 ? 'Normal' : e[0].comodin.toString(),
          idComodin: e[0].comodin.toString(),
          dietaryCategory3: e[0].car_nombre_jer,
          idDietaryCategory3: e[0].id_categoria_dietetica.toString(),
        })
      }
    })
    
    // CRÍTICO: Eliminar duplicados basándose en estructura, ingrediente, comodín y categoría dietética
    // Si la misma estructura aparece en diferentes contratos, mantener solo el primero
    const data4SinDuplicados: contStep4[] = []
    const estructurasVistas = new Map<string, boolean>()
    
    data4.forEach((item: any) => {
      // Crear clave única basada en estructura, ingrediente, comodín y categoría dietética
      const nombreEstructura = (item.fatherStructure3 || '').trim().toLowerCase()
      const claveUnica = `${nombreEstructura}-${item.idMainIngredients2}-${item.idComodin}-${item.idDietaryCategory3}`
      
      // Solo agregar si no se ha visto antes
      if (!estructurasVistas.has(claveUnica)) {
        estructurasVistas.set(claveUnica, true)
        data4SinDuplicados.push(item)
      }
    })
    
    // Actualizar los IDs para que sean secuenciales después de eliminar duplicados
    data4SinDuplicados.forEach((item: any, index: number) => {
      item.id = index
      item.idDelete = index
    })
    
    // Guardar todas las frecuencias sin filtrar para validaciones
    setTodasLasFrecuenciasSinFiltrar(data4SinDuplicados)
    setDataRow4(data4SinDuplicados)
    
    const totalEstructurasTabla = dataStep2.length
    const estructurasBase = dataStep2.filter((item: any) => item.contrato == contrato.id).length
    const estructurasMultiplesTabla = dataStep2.filter((item: any) => item.contrato != contrato.id).length
    
    setLoad(false)
    setIsHomologada(dataStep1.homologada)
    setIsReady(true)
    // } catch (e: any) {
    //   setLoad(false)
    //   error(e)
    // }
  }

  const getContrHomologado = (id: any, contrs: any[]) => {
    let templateHomo: any[] = []
    if (id && id > 0) {
      const contFinded: any = contrs.find((e: any) => id == e.id)

      templateHomo = [
        {
          text: `${contFinded.id} - ${contFinded.ceco} ${contFinded.cli_nombre} ${contFinded.reg_codigo} ${contFinded.regimen} ${contFinded.codServicio} ${contFinded.servicio}`,
          value: parseInt(id),
        },
      ]
    }

    return templateHomo
  }

  const cargarEstructurasMultiples = async () => {
    // Obtener el contrato actual del contexto
    const state: any = location.state
    const contrato = state?.contrato || state?.params || {id: 0}
    
    let estructurasMultiples: any[] = []
    
    try {
      const estructurasMultiplesStr = localStorage.getItem('estructurasMultiples')
      if (estructurasMultiplesStr && estructurasMultiplesStr !== '[]' && estructurasMultiplesStr !== '') {
        estructurasMultiples = JSON.parse(estructurasMultiplesStr)
        if (!Array.isArray(estructurasMultiples)) {
          estructurasMultiples = []
        }
      }
    } catch (e) {
      estructurasMultiples = []
    }
    
    if (!estructurasMultiples || estructurasMultiples.length === 0) {
      return
    }
    
    // Obtener SOLO los contratos seleccionados al inicio para validar
    let contratosSeleccionadosAlInicio: any[] = []
    try {
      // Contrato de Homologada Origen
      const contratoOrigenStr = localStorage.getItem('contratoOrigenSeleccionado')
      if (contratoOrigenStr && contratoOrigenStr !== '') {
        contratosSeleccionadosAlInicio.push(parseInt(contratoOrigenStr))
      }
      
      // Contratos de Homologada Destino Multiple
      const templateHomologada2Str = localStorage.getItem('templateHomologada2')
      if (templateHomologada2Str && templateHomologada2Str !== '[]' && templateHomologada2Str !== '') {
        const templateHomologada2 = JSON.parse(templateHomologada2Str)
        if (Array.isArray(templateHomologada2) && templateHomologada2.length > 0) {
          const contratosDestinoMultiple = templateHomologada2
            .map((item: any) => {
              return typeof item === 'object' && item !== null ? (item.value || item) : item
            })
            .filter((id: any) => id)
          contratosSeleccionadosAlInicio = [...contratosSeleccionadosAlInicio, ...contratosDestinoMultiple]
        }
      }
    } catch (e) {
    }
    
    // Filtrar estructurasMultiples para SOLO incluir estructuras de contratos seleccionados al inicio
    const estructurasMultiplesFiltradas = estructurasMultiples.filter((e: any) => {
      return contratosSeleccionadosAlInicio.includes(e.contratoId)
    })
    
    if (estructurasMultiplesFiltradas.length === 0) {
      return
    }
    
    // Eliminar estructuras de contratos no seleccionados al inicio
    const contratosNoSeleccionados = estructurasMultiples
      .filter((e: any) => !contratosSeleccionadosAlInicio.includes(e.contratoId))
      .map((e: any) => e.contratoId)
    
    if (contratosNoSeleccionados.length > 0) {
      const contratosNoSeleccionadosUnicos = Array.from(new Set(contratosNoSeleccionados))
    }
    
    // CRÍTICO: Solo usar contratos seleccionados al inicio, NO contratos de estructurasMultiples
    // estructurasMultiples puede contener contratos no seleccionados al inicio
    const contratosSeleccionadosAlInicioParaMultiples = obtenerContratosSeleccionadosAlInicio({data: {result: []}}, contrato)
    const contratosSeleccionadosNormalizadosParaMultiples = Array.from(new Set(contratosSeleccionadosAlInicioParaMultiples.map((id: any) => {
      return typeof id === 'string' ? parseInt(id) : id
    }).filter((id: any) => id && !isNaN(id))))
    
    // Filtrar estructurasMultiplesFiltradas para SOLO incluir contratos seleccionados al inicio
    const estructurasMultiplesFiltradasPorSeleccionados = estructurasMultiplesFiltradas.filter((e: any) => {
      const eContratoIdNum = typeof e.contratoId === 'string' ? parseInt(e.contratoId) : e.contratoId
      return contratosSeleccionadosNormalizadosParaMultiples.includes(eContratoIdNum)
    })
    
    const contratosUnicos: any[] = Array.from(new Set(estructurasMultiplesFiltradasPorSeleccionados.map((e: any) => {
      const eContratoIdNum = typeof e.contratoId === 'string' ? parseInt(e.contratoId) : e.contratoId
      return eContratoIdNum
    })))
    setLoad(true)
    
    try {
      const promesasContratos = contratosUnicos.map(async (contratoId: any) => {
        const contratoIdNumParaMultiples = typeof contratoId === 'string' ? parseInt(contratoId) : contratoId
        
        // VALIDACIÓN CRÍTICA: Solo llamar si el contrato está en la lista de seleccionados al inicio
        if (!contratosSeleccionadosNormalizadosParaMultiples.includes(contratoIdNumParaMultiples)) {
          return []
        }
        
        const datosContratoMultiple: any = await callSP('amd_getDatosByContrato', [
          {text: 'contrato', value: contratoIdNumParaMultiples.toString()},
          {text: 'id_minuta', value: ''},
        ])
        
        if (datosContratoMultiple?.data?.result) {
          const estructurasIdsDeEsteContrato = estructurasMultiplesFiltradasPorSeleccionados
            .filter((e: any) => {
              const eContratoIdNum = typeof e.contratoId === 'string' ? parseInt(e.contratoId) : e.contratoId
              return eContratoIdNum === contratoIdNumParaMultiples
            })
            .map((e: any) => e.id)
          
          const filtradas = datosContratoMultiple.data.result.filter((item: any) => {
            return estructurasIdsDeEsteContrato.includes(item.id_estructura_contrato) ||
                   estructurasIdsDeEsteContrato.includes(item.id_estructura) ||
                   estructurasIdsDeEsteContrato.includes(item.cod_estructura)
          })
          
          const estructurasUnicas = new Set(filtradas.map((e: any) => e.id_estructura_contrato))
          
          return filtradas.map((item: any) => ({
            ...item,
            contratoOrigen: contratoIdNumParaMultiples,
            id_contrato: contratoIdNumParaMultiples
          }))
        }
        return []
      })
      
      const resultados = await Promise.all(promesasContratos)
      const datosContratosMultiples = resultados.flat()
      
      if (datosContratosMultiples.length > 0) {
        // VALIDACIÓN FINAL: Asegurar que solo se agreguen estructuras de contratos seleccionados al inicio
        const contratosPermitidos = contratosSeleccionadosAlInicio.length > 0 
          ? contratosSeleccionadosAlInicio 
          : []
        
        const datosContratosMultiplesFiltrados = datosContratosMultiples.filter((item: any) => {
          const contratoDelItem = item.contratoOrigen || item.id_contrato
          const estaPermitido = contratosPermitidos.includes(contratoDelItem) || contratosPermitidos.includes(parseInt(contratoDelItem))
          
          return estaPermitido || contratosPermitidos.length === 0 // Si no hay contratos seleccionados, no filtrar (caso inicial)
        })
        
        // CRÍTICO: Agrupar por id_estructura_contrato Y contrato para evitar duplicados entre contratos
        const gruop: any = {}
        datosContratosMultiplesFiltrados.forEach((item: any) => {
          const contratoOrigen = item.contratoOrigen || item.id_contrato
          const contratoOrigenNum = contratoOrigen ? (typeof contratoOrigen === 'string' ? parseInt(contratoOrigen) : contratoOrigen) : null
          const idEstructuraContrato = item.id_estructura_contrato
          
          // Crear una clave única: id_estructura_contrato-contrato
          const key = `${idEstructuraContrato}-${contratoOrigenNum || 'sin_contrato'}`
          
          if (!gruop[key]) {
            gruop[key] = []
          }
          gruop[key].push(item)
        })
        
        // CRÍTICO: Crear el mapa de dias_bloqueados desde dataEstructuraByContrato UNA SOLA VEZ
        const mapaDiasBloqueadosMultiples = new Map<string, string>()
        if (dataEstructuraByContrato.length > 0) {
          dataEstructuraByContrato.forEach((estructura: any) => {
            const idEstructuraContrato = estructura.id || estructura.idO || estructura.id_estructura_contrato
            const codEstructura = estructura.cod_estructura
            const idEstructura = estructura.id_estructura
            const contratoOrigen = estructura.contratoOrigen
            
            if (estructura.dias_bloqueados && estructura.dias_bloqueados.trim() !== '') {
              if (idEstructuraContrato && contratoOrigen) {
                const key1 = `${idEstructuraContrato}-${contratoOrigen}`
                mapaDiasBloqueadosMultiples.set(key1, estructura.dias_bloqueados)
              }
              if (codEstructura && contratoOrigen) {
                const key2 = `${codEstructura}-${contratoOrigen}`
                if (!mapaDiasBloqueadosMultiples.has(key2)) {
                  mapaDiasBloqueadosMultiples.set(key2, estructura.dias_bloqueados)
                }
              }
              if (idEstructura && contratoOrigen) {
                const key3 = `${idEstructura}-${contratoOrigen}`
                if (!mapaDiasBloqueadosMultiples.has(key3)) {
                  mapaDiasBloqueadosMultiples.set(key3, estructura.dias_bloqueados)
                }
              }
            }
          })
        }
        
        const estructurasExistentes = [...dataRow2]
        
        // Crear un Set para verificar duplicados usando id_estructura_contrato y contrato
        const estructurasYaAgregadas = new Set<string>()
        estructurasExistentes.forEach((est: any) => {
          const contratoEst = est.contrato || 0
          const idEstRel = est.idEstRel || 0
          const key = `${idEstRel}-${contratoEst}`
          estructurasYaAgregadas.add(key)
        })
        
        // Iterar sobre las estructuras agrupadas y agregar solo un representante de cada grupo
        for (const key in gruop) {
          if (Object.prototype.hasOwnProperty.call(gruop, key)) {
            const groupItems = gruop[key]
            if (groupItems.length > 0) {
              const dato = groupItems[0] // Tomar el primer elemento como representante de la estructura única
              
              // Verificar si esta estructura ya existe en estructurasExistentes
              const contratoIdCheck = dato.contratoOrigen || dato.id_contrato || 0
              const contratoIdNumCheck = contratoIdCheck ? (typeof contratoIdCheck === 'string' ? parseInt(contratoIdCheck) : contratoIdCheck) : 0
              const idEstructuraContratoCheck = dato.id_estructura_contrato || 0
              const keyDuplicado = `${idEstructuraContratoCheck}-${contratoIdNumCheck}`
              
              // Si ya existe, saltar esta estructura
              if (estructurasYaAgregadas.has(keyDuplicado)) {
                continue
              }
          const findedPlato: any = tipoPlatos.find((p: any) => dato.tipo_plato == p.tip_codigo)
          let arrTP: any[] = []
          if (findedPlato && findedPlato.tip_previo == 0) {
            const tt: any[] = await getPlateTypesLevels(findedPlato.tip_codigo, tipoPlatos)
            tt.push(findedPlato.tip_codigo)
            arrTP = tt
          } else if (findedPlato) {
            const types: any[] = tipoPlatos
              .filter((e: any) => e.tip_previo == findedPlato.tip_codigo)
              .map((e: any) => e.tip_codigo)
            arrTP = types
          }
          
          // CRÍTICO: Buscar dias_bloqueados en el mapa de amd_getEstructuraByContrato
          // porque amd_getDatosByContrato puede no tener este campo
          let diasBloqueadosStr = dato.dias_bloqueados
          let mapBlockedD: any[] = []
          
          // Si no hay dias_bloqueados en amd_getDatosByContrato, buscar en el mapa
          if ((!diasBloqueadosStr || diasBloqueadosStr === '' || diasBloqueadosStr.trim() === '') && mapaDiasBloqueadosMultiples.size > 0) {
            
            // Buscar en el mapa
            const idEstructuraContrato = dato.id_estructura_contrato
            const codEstructura = dato.cod_estructura
            const idEstructura = dato.id_estructura
            const id = dato.id
            const contratoOrigenNum = dato.contratoOrigen || dato.id_contrato
            const contratoOrigenNumFinal = contratoOrigenNum ? (typeof contratoOrigenNum === 'string' ? parseInt(contratoOrigenNum) : contratoOrigenNum) : null
            
            // Intentar múltiples claves
            if (idEstructuraContrato && contratoOrigenNumFinal) {
              const key1 = `${idEstructuraContrato}-${contratoOrigenNumFinal}`
              diasBloqueadosStr = mapaDiasBloqueadosMultiples.get(key1) || diasBloqueadosStr
            }
            if ((!diasBloqueadosStr || diasBloqueadosStr === '') && id && contratoOrigenNumFinal) {
              const keyId = `${id}-${contratoOrigenNumFinal}`
              diasBloqueadosStr = mapaDiasBloqueadosMultiples.get(keyId) || diasBloqueadosStr
            }
            if ((!diasBloqueadosStr || diasBloqueadosStr === '') && codEstructura && contratoOrigenNumFinal) {
              const key2 = `${codEstructura}-${contratoOrigenNumFinal}`
              diasBloqueadosStr = mapaDiasBloqueadosMultiples.get(key2) || diasBloqueadosStr
            }
            if ((!diasBloqueadosStr || diasBloqueadosStr === '') && idEstructura && contratoOrigenNumFinal) {
              const key3 = `${idEstructura}-${contratoOrigenNumFinal}`
              diasBloqueadosStr = mapaDiasBloqueadosMultiples.get(key3) || diasBloqueadosStr
            }
            
            // Búsqueda sin contrato específico
            if ((!diasBloqueadosStr || diasBloqueadosStr === '') && idEstructuraContrato) {
              const clavesCoincidentes = Array.from(mapaDiasBloqueadosMultiples.keys()).filter((k: string) => 
                k.startsWith(`${idEstructuraContrato}-`)
              )
              if (clavesCoincidentes.length > 0) {
                diasBloqueadosStr = mapaDiasBloqueadosMultiples.get(clavesCoincidentes[0]) || diasBloqueadosStr
              }
            }
            if ((!diasBloqueadosStr || diasBloqueadosStr === '') && codEstructura) {
              const clavesCoincidentes = Array.from(mapaDiasBloqueadosMultiples.keys()).filter((k: string) => 
                k.startsWith(`${codEstructura}-`)
              )
              if (clavesCoincidentes.length > 0) {
                diasBloqueadosStr = mapaDiasBloqueadosMultiples.get(clavesCoincidentes[0]) || diasBloqueadosStr
              }
            }
          }
          
          // Procesar dias_bloqueados si existe
          if (diasBloqueadosStr && diasBloqueadosStr !== '' && diasBloqueadosStr.trim() !== '') {
            mapBlockedD = diasBloqueadosStr.toString()
              .split(',')
              .map((d: string) => parseInt(d.trim()))
              .filter((d: number) => !isNaN(d) && d > 0)
          } else {
            mapBlockedD = []
          }
          
          // VALIDACIÓN: Asegurar que el contrato esté en la lista permitida
          const contratoId = dato.contratoOrigen || dato.id_contrato || 0
          const contratoIdNum = contratoId ? (typeof contratoId === 'string' ? parseInt(contratoId) : contratoId) : null
          
          // Si el contrato NO está en la lista permitida, NO agregar esta estructura
          if (contratoIdNum && !contratosSeleccionadosAlInicio.includes(contratoIdNum)) {
            continue // Saltar esta estructura
          }
          
          const itemStep2: contStep2 = {
            load: true,
            idEstRel: dato.id_estructura_contrato || 0,
            contrato: contratoIdNum || 0,
            fatherStructure: dato.tipo_estructura,
            idFatherStructure: dato.id_grupo_estructura,
            tolerance: dato.NombreIntolerancia,
            idTolerance: dato.id_intolerancia,
            allergens: dato.NombreAlergeno,
            idAllergens: dato.id_alergeno,
            structure: dato.estructura,
            idStructure: dato.id_estructura_hijo,
            idStru: dato.id_estructura,
            dietaryCategory: dato.car_nombre,
            dietaryCategoryAll: dato.car_nombre_jer_estructura || dato.car_nombre_jer,
            idDietaryCategory: dato.id_categoria_dietetica_estructura || dato.id_categoria_dietetica,
            id: estructurasExistentes.length,
            data: {
              blockedDays: mapBlockedD,
            },
            blockedDays: mapBlockedD.length > 0 ? mapBlockedD.map((d: any) => mapDaysStr(d)).join(',') : 'No aplica',
            idBlockedDays: mapBlockedD,
            idPlateType: dato.tipo_plato,
            plateType: dato.nombre_tipo_plato,
            plateTypes: arrTP,
            order: dato.orden || estructurasExistentes.length,
          }
          
              estructurasExistentes.push(itemStep2)
              // Agregar al Set para evitar duplicados
              estructurasYaAgregadas.add(keyDuplicado)
            }
          }
        }
        
        // VALIDACIÓN FINAL CRÍTICA: Filtrar estructurasExistentes antes de establecerlo
        // cargarEstructurasMultiples siempre es en modo creación, no edición
        const estructurasExistentesValidadas = validarYFiltrarDataRow2(estructurasExistentes, contrato, undefined, false)
        
        // Guardar en variable de ámbito de función para usar en el filtro de dataRow3
        // @ts-expect-error - La variable está definida al inicio de la función, TypeScript no puede inferir el scope correctamente
        estructurasValidadasParaFiltro = estructurasExistentesValidadas
        
        setDataRow2(estructurasExistentesValidadas)
        const nuevasEstructuras = estructurasExistentesValidadas.length - dataRow2.length
      }
    } catch (e: any) {
    } finally {
      setLoad(false)
    }
    
    // CRÍTICO: Filtrar formContract3 para incluir SOLO recetas fijas de estructuras seleccionadas en el modal
    // El campo "nombre" de las estructuras debe coincidir con el campo "estructura" de las recetas
    const filtrarRecetasFijasPorEstructuras = (recetasFijas: contStep3[], estructurasValidadas: any[]) => {
      if (recetasFijas && recetasFijas.length > 0) {
        // CRÍTICO: Obtener NOMBRES de estructuras seleccionadas desde localStorage
        const nombresEstructurasSeleccionadas = new Set<string>()

        try {
          // 1. Obtener nombres de estructuras del contrato origen
          const estructurasConNombresStr = localStorage.getItem('estructurasSeleccionadasConNombres')
          if (estructurasConNombresStr && estructurasConNombresStr !== '[]' && estructurasConNombresStr !== '') {
            const estructurasConNombres = JSON.parse(estructurasConNombresStr)
            if (Array.isArray(estructurasConNombres)) {
              estructurasConNombres.forEach((est: any) => {
                if (est.nombre) {
                  nombresEstructurasSeleccionadas.add(est.nombre.toLowerCase().trim())
                }
              })
            }
          }

          // 2. Obtener nombres de estructuras múltiples seleccionadas
          const estructurasMultiplesStr = localStorage.getItem('estructurasMultiples')
          if (estructurasMultiplesStr && estructurasMultiplesStr !== '[]' && estructurasMultiplesStr !== '') {
            const estructurasMultiples = JSON.parse(estructurasMultiplesStr)
            if (Array.isArray(estructurasMultiples)) {
              estructurasMultiples.forEach((est: any) => {
                const nombre = (est.ess_nombre || est.nombre || est.estructura || '').toLowerCase().trim()
                if (nombre) {
                  nombresEstructurasSeleccionadas.add(nombre)
                }
              })
            }
          }
        } catch (e) {
        }

        // Si no hay estructuras seleccionadas en localStorage, no filtrar
        if (nombresEstructurasSeleccionadas.size === 0) {
          setDataRow3(recetasFijas)
          return
        }
        
        // Filtrar: el campo fatherStructure2 (que es "estructura") debe estar en los nombres seleccionados
        const formContract3Filtrado = recetasFijas.filter((receta: any) => {
          const nombreEstructuraReceta = receta.fatherStructure2 ? receta.fatherStructure2.toLowerCase().trim() : ''
          const estaSeleccionada = nombreEstructuraReceta && nombresEstructurasSeleccionadas.has(nombreEstructuraReceta)
          
          return estaSeleccionada
        })
        
        setDataRow3(formContract3Filtrado)
      } else {
        setDataRow3([])
      }
    }
  }

  const clearDataGrid = () => {
    setInitValues(inits)
    setDataRow2([])
    setDataRow3([])
    setDataRow4([])
    setDataRow6([])
  }

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    setSubmitButton(false)
    stepper.current.goPrev()
    setContractSchemas(createContractSchemas[stepper.current.currentStepIndex - 1])
  }

  async function amd_updateContrato(values: any) {
    let comensales: any = [
      values.quantityMonday,
      values.quantityTuesday,
      values.quantityWednesday,
      values.quantityThursday,
      values.quantityFriday,
      values.quantitySaturday,
      values.quantitySunday,
    ]
    let estructurasTp: any = []
    let idPlateType: any = []
    let idDietaryCategory: any = []
    let idAllergens: any = []
    let idTolerance: any = []

    dataRow2.forEach(function (item: any) {
      estructurasTp.push(item.idStru)
      idPlateType.push(item.idPlateType)
      idDietaryCategory.push(item.idDietaryCategory)
      idAllergens.push(item.idAllergens)
      idTolerance.push(item.idTolerance)
    })

    let _estEliminar = await getLStorage('estEliminar')
    let _estNuevo = await getLStorage('estNuevo')
    let _estGENuevo = await getLStorage('estGENuevo')
    let _recFij = await getLStorage('recFij')
    let _recFijRec = await getLStorage('recFijRec')
    let _recFijCD = await getLStorage('recFijCD')
    let _frecEstructura = await getLStorage('frecEstructura')
    let _frecIngrediente = await getLStorage('frecIngrediente')
    let _frecCD = await getLStorage('frecCD')
    let _estIDGENuevo = await getLStorage('estIDGENuevo')

    const estEliminar =
      _estEliminar == null ? [] : _estEliminar.filter((item: any) => item.trim() !== '')
    const estNuevo = _estNuevo == null ? [] : _estNuevo.filter((item: any) => item.trim() !== '')
    const estGENuevo =
      _estGENuevo == null ? [] : _estGENuevo.filter((item: any) => item.trim() !== '')
    const recFij = _recFij == null ? [] : _recFij.filter((item: any) => item.trim() !== '')
    const recFijRec = _recFijRec == null ? [] : _recFijRec.filter((item: any) => item.trim() !== '')
    const recFijCD = _recFijCD == null ? [] : _recFijCD.filter((item: any) => item.trim() !== '')
    const frecEstructura =
      _frecEstructura == null ? [] : _frecEstructura.filter((item: any) => item.trim() !== '')
    const frecIngrediente =
      _frecIngrediente == null ? [] : _frecIngrediente.filter((item: any) => item.trim() !== '')
    const frecCD = _frecCD == null ? [] : _frecCD.filter((item: any) => item.trim() !== '')
    const estIDGENuevo =
      _estIDGENuevo == null ? [] : _estIDGENuevo.filter((item: any) => item.trim() !== '')

    var parameters: any = [
      {
        text: 'contrato',
        value: values.contractId + '',
      },
      {
        text: 'dia_semana',
        value: '1,2,3,4,5,6,7',
      },
      {
        text: 'comensales',
        value: comensales.join(','),
      },
      {
        text: 'estructurasTp',
        value: estructurasTp.join(','),
      },
      {
        text: 'tp',
        value: idPlateType.join(','),
      },
      {
        text: 'estructurasCD',
        value: estructurasTp.join(','),
      },
      {
        text: 'cd',
        value: idDietaryCategory.join(','),
      },
      {
        text: 'estructurasAl',
        value: estructurasTp.join(','),
      },
      {
        text: 'al',
        value: idAllergens.join(','),
      },
      {
        text: 'estructurasInt',
        value: estructurasTp.join(','),
      },
      {
        text: 'intolerancia',
        value: idTolerance.join(','),
      },
      {
        text: 'estEliminar',
        value: estEliminar.length > 0 ? estEliminar.join(',') : '',
      },
      {
        text: 'estNuevo',
        value: estNuevo.length > 0 ? estNuevo.join(',') : '',
      },
      {
        text: 'estGENuevo',
        value: estGENuevo.length > 0 ? estGENuevo.join(',') : '',
      },
      {
        text: 'recFij',
        value: recFij.length > 0 ? recFij.join(',') : '',
      },
      {
        text: 'recFijRec',
        value: recFijRec.length > 0 ? recFijRec.join(',') : '',
      },
      {
        text: 'recFijCD',
        value: recFijCD.length > 0 ? recFijCD.join(',') : '',
      },
      {
        text: 'frecEstructura',
        value: frecEstructura.length > 0 ? frecEstructura.join(',') : '',
      },
      {
        text: 'frecIngrediente',
        value: frecIngrediente.length > 0 ? frecIngrediente.join(',') : '',
      },
      {
        text: 'frecCD',
        value: frecCD.length > 0 ? frecCD.join(',') : '',
      },
      {
        text: 'estIDGENuevo',
        value: estIDGENuevo.length > 0 ? estIDGENuevo.join(',') : '',
      },
    ]

    setLoad(true)
    try {
      const responseServices: any = await callSP('amd_updateContrato', parameters)

      setLoad(false)
      
      if (responseServices.data.status === '200' || responseServices.data.status === 200) {
        success('Contrato actualizado')
      } else {
        error('Error actualizando contrato')
      }

      return responseServices.data.status
    } catch (error: any) {
      setLoad(false)
      error('Error actualizando contrato')
      throw error
    }
  }

  const submitStep = async (values: ICreateContract, actions: FormikValues) => {
    if (!stepper.current) {
      return
    }

    dispatch(contractRedux.actions.setContract(values))

    setSubmitButton(stepper.current.currentStepIndex === stepper.current.totatStepsNumber! - 1)
    setLStorage('reloadGrid', 'false')
    if (stepper.current.currentStepIndex === 1) {
      setIsHomologada(values.homologada)
      setReloadStep2(true)
      if (hasContract) setLStorage('reloadGrid', 'true')
      if (validateStep1(values)) {
        // Avanzar inmediatamente - cargar estructuras en segundo plano
        stepper.current.goNext()
        
        // Cargar estructuras de contratos múltiples en segundo plano (no bloquear navegación)
        cargarEstructurasMultiples().catch((error) => {
          // Error en cargarEstructurasMultiples
        })
      } else {
        stepper.current.goto(1)
      }
      return
    } else {
      setReloadStep2(false)
    }

    if (stepper.current.currentStepIndex === 2) {
      if (dataRow2.length) {
        stepper.current.goNext()
      } else {
        warn('Debe crear estructuras')
        stepper.current.goto(2)
      }
      return
    }

    if (stepper.current.currentStepIndex === 3) {
      setReload3(true)
    } else {
      setReload3(false)
    }

    if (stepper.current.currentStepIndex === 4) {
      setReload4(true)
      const contStp4 = await validateFixedRecipe(values)
      if (contStp4) {
        setContractSchemas(createContractSchemas[stepper.current.currentStepIndex])
        if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber) {
          stepper.current.goNext()
        } else {
          stepper.current.goto(1)
        }
        return
      } else {
        setSubmitButton(false)
        return
      }
    } else {
      setReload4(false)
    }

    if (stepper.current.currentStepIndex === 5) {
      setReload5(true)
      const contStp5 = await validateIngredientFrequency(values)
      if (contStp5) {
        setContractSchemas(createContractSchemas[stepper.current.currentStepIndex])
        if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber) {
          stepper.current.goNext()
        } else {
          stepper.current.goto(1)
          actions.resetForm()
        }
        return
      } else {
        setSubmitButton(false)
        return
      }
    } else {
      setReload5(false)
    }

    if (stepper.current.currentStepIndex === 6) {
      if (validateStep6(values)) {
        setLoad(true)
        let resp: any = null
        let resp2: any = null
        let responseEstFija: any = null

        const state2: any = location.state
        let contract2: any = null
        if (state2?.params) {
          contract2 = {
            ...state2?.params,
            id: state2?.contrato,
          }
        }
        if (contract2?.plantilla > 0 || contract2?.minuta > 0) {
          values.contractId = await getSStorage('contractId')
          resp2 = await amd_updateContrato(values)

          const arrayBodyEstFija: any[] = []
          if (dataRow6.length) {
            const idContrato = dataRow6
              .filter((item) => item.data.id_contrato !== undefined)[0].data.id_contrato?.toString();
            dataRow6.forEach((e: any, i: number) => {
              arrayBodyEstFija.push(
                setParametersEstFija(
                  i.toString(),
                  (e.data.id_contrato?.toString() ||idContrato),
                  e.idRecipe.toString(),
                  e.idFatherStructure4.toString(),
                  e.idEstRel ? e.idEstRel.toString() : '0',
                  e.id_estructura?.toString() || e.data.structure[0].ess_codigo.toString()                )
              )
            })
          }

          responseEstFija = await callSPUp('amd_insertEstructuraFija', arrayBodyEstFija)
        } else {
          resp = await saveContract(values, dataRow2, dataRow6, dataRow3, dataRow4, isHomologada)
        }

        removeSStorage('contractId')

        if (resp || resp2) {
          setLoad(false)
          navigate(-1)
        }
        setLoad(false)
      }
    } else {
      setContractSchemas(createContractSchemas[stepper.current.currentStepIndex])
      if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber) {
        stepper.current.goNext()
      } else {
        stepper.current.goto(1)
        actions.resetForm()
      }
    }
  }

  const setParametersEstFija = (
    id: string,
    id_contrato: string,
    id_receta: string,
    id_grupo_estructura: string,
    id_est_rel: string,
    id_estructura: string
  ) => {
    return {
      parameters: [
        {text: 'id', value: id},
        {text: 'id_contrato', value: id_contrato},
        {text: 'id_receta', value: id_receta},
        {text: 'id_grupo_estructura', value: id_grupo_estructura},
        {text: 'id_est_rel', value: id_est_rel},
        {text: 'indice', value: id},
        {text: 'id_estructura', value: id_estructura},
      ],
    }
  }

  const validateFixedRecipe = useCallback(
    async (values: ICreateContract) => {
      let dr2: any = dataRow2
      if (dr2.length === 0) {
        dr2 = await getLStorage('dataRow2')
        dr2 = JSON.parse(dr2)
      }
      const {continueStep, warnBlockDays} = validateStep4(dr2, dataRow3, values)
      if (!continueStep) {
        warn(warnBlockDays)
      }
      return continueStep
    },
    [dataRow2, dataRow3, stepper]
  )

  const validateIngredientFrequency = useCallback(
    async (values: ICreateContract) => {
      let dr2: any = dataRow2
      if (dr2.length === 0) {
        dr2 = await getLStorage('dataRow2')
        dr2 = JSON.parse(dr2)
      }
      const {
        total,
        continueStep,
        structure,
        diasBloqueados,
        totalEstructuraPadre,
        totalEstructuraComodin,
        continueAdjacent,
        warnAdjacent,
      } = validateIngredientsFrequency(dataRow3, dataRow4, values, dr2, ingAdyacentes, todasLasFrecuenciasSinFiltrar)
      if (values.templateType) {
        if (values.templateType[0].value == 3) {
          let continueComedin = false
          let nameStructure = ''
          let comodin = ''
          const arrayComodin = ['29', '30', '31']
          const data = Object.keys(totalEstructuraPadre)
          data.map((strucPadre: any, key: number) => {
            arrayComodin.map((item: any, key: number) => {
              if (totalEstructuraComodin[strucPadre][item] === undefined) {
                continueComedin = true
                comodin = item
                nameStructure = strucPadre
              } else {
                if (!continueComedin) {
                  nameStructure = ''
                }
              }
            })
          })
          nameStructure = nameStructure ? nameStructure : structure
          if (continueComedin) {
            warn('A la estructura ' + nameStructure + ' le faltan ingresar el comodin ' + comodin)
            return
          }
        }
      }
      if (!continueStep) {
        const frecuency = values.frequencyCycle ? values.frequencyCycle : 0
        const diasBloq = diasBloqueados[structure] ? diasBloqueados[structure] : 0
        warn(
          'La cantidad de la frecuencia de ' +
            (frecuency - diasBloq) +
            ' no cuadra con la estructura ' +
            structure
        )
      }
      if (!continueAdjacent) warn(warnAdjacent)

      return continueStep && continueAdjacent
    },
    [dataRow4, stepper, dataRow3]
  )

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  // Filtrar recetaFija para mostrar SOLO las que fueron seleccionadas en el modal inicial
  const recetaFijaFiltrada = useMemo(() => {
    try {
      // En modo edición, devolver TODAS las recetas fijas sin filtrar
      // porque necesitamos acceso a todas para poder editar cualquier receta
      if (editContract) {
        return recetaFija
      }
      
      // Crear Sets para IDs seleccionados
      let idsEstructurasSeleccionadas: Set<string> = new Set()
      
      // 1. Obtener estructuras FIJAS del contrato origen (base) - SOLO las que fueron SELECCIONADAS
      try {
        const estructurasFijasSeleccionadasStr = localStorage.getItem('estructurasFijasSeleccionadas')
        if (estructurasFijasSeleccionadasStr && estructurasFijasSeleccionadasStr !== '[]' && estructurasFijasSeleccionadasStr !== '') {
          const estructurasFijasSeleccionadas = JSON.parse(estructurasFijasSeleccionadasStr)
          if (Array.isArray(estructurasFijasSeleccionadas) && estructurasFijasSeleccionadas.length > 0) {
            estructurasFijasSeleccionadas.forEach((ef: any) => {
              if (ef.id_receta) {
                idsEstructurasSeleccionadas.add(ef.id_receta?.toString())
              }
              if (ef.id && ef.id !== 0) {
                idsEstructurasSeleccionadas.add(ef.id?.toString())
              }
            })
          }
        }
      } catch (e) {
      }
      
      // 2. Obtener estructuras fijas múltiples seleccionadas
      try {
        const estructurasFijasMultiplesStr = localStorage.getItem('estructurasFijasMultiples')
        if (estructurasFijasMultiplesStr && estructurasFijasMultiplesStr !== '[]' && estructurasFijasMultiplesStr !== '') {
          const estructurasFijasMultiples = JSON.parse(estructurasFijasMultiplesStr)
          if (Array.isArray(estructurasFijasMultiples)) {
            estructurasFijasMultiples.forEach((ef: any) => {
              if (ef.id_receta) {
                idsEstructurasSeleccionadas.add(ef.id_receta?.toString())
              }
              if (ef.id && ef.id !== 0) {
                idsEstructurasSeleccionadas.add(ef.id?.toString())
              }
            })
          }
        }
      } catch (e) {
      }
      
      // Filtrar recetaFija INCLUYENDO SOLO las que fueron seleccionadas
      if (idsEstructurasSeleccionadas.size > 0) {
        const filtradas = recetaFija.filter((rec: any) => {
          const idReceta = rec.id_receta ? rec.id_receta.toString() : null
          const recCodigo = rec.rec_codigo ? rec.rec_codigo.toString() : (rec.value ? rec.value.toString() : null)
          const id = rec.id ? rec.id.toString() : null
          
          const idsPosibles = [idReceta, recCodigo, id].filter((i: any) => i && i !== 'undefined' && i !== 'null' && i !== '0')
          
          return idsPosibles.some((i: string) => idsEstructurasSeleccionadas.has(i))
        })
        
        return filtradas
      } else {
        return []
      }
    } catch (e) {
      return []
    }
  }, [recetaFija, editContract])
  
  // Filtrar recetaEstructuraFijas para mostrar SOLO las que fueron seleccionadas en el modal inicial
  // CRÍTICO: Solo mostrar las estructuras fijas que el usuario seleccionó al inicio
  const recetaEstructuraFijasFiltradas = useMemo(() => {
    try {
      // CRÍTICO: Solo procesar si hay un contrato origen seleccionado
      // Esto evita procesar datos residuales de localStorage cuando se carga la página sin seleccionar nada
      const contratoOrigenSeleccionado = localStorage.getItem('contratoOrigenSeleccionado')
      if (!contratoOrigenSeleccionado && !editContract) {
        // No hay contrato origen seleccionado y no estamos en modo edición, retornar vacío
        return []
      }
      
      // Crear Sets para IDs seleccionados
      let idsEstructurasSeleccionadas: Set<string> = new Set()
      
      // 1. Obtener estructuras FIJAS del contrato origen (base) - SOLO las que fueron SELECCIONADAS
      try {
        const estructurasFijasSeleccionadasStr = localStorage.getItem('estructurasFijasSeleccionadas')
        if (estructurasFijasSeleccionadasStr && estructurasFijasSeleccionadasStr !== '[]' && estructurasFijasSeleccionadasStr !== '') {
          const estructurasFijasSeleccionadas = JSON.parse(estructurasFijasSeleccionadasStr)
          if (Array.isArray(estructurasFijasSeleccionadas) && estructurasFijasSeleccionadas.length > 0) {
            estructurasFijasSeleccionadas.forEach((ef: any) => {
              // CRÍTICO: NO agregar id_estructura si es 0 (todas las estructuras fijas tienen id_estructura: 0)
              // Solo agregar id_receta (identificador principal) y id (ID del registro)
              if (ef.id_receta) {
                idsEstructurasSeleccionadas.add(ef.id_receta?.toString())
              }
              if (ef.id && ef.id !== 0) {
                idsEstructurasSeleccionadas.add(ef.id?.toString())
              }
            })
          }
        }
      } catch (e) {
      }
      
      // 2. Obtener estructuras fijas múltiples seleccionadas
      try {
        const estructurasFijasMultiplesStr = localStorage.getItem('estructurasFijasMultiples')
        if (estructurasFijasMultiplesStr && estructurasFijasMultiplesStr !== '[]' && estructurasFijasMultiplesStr !== '') {
          const estructurasFijasMultiples = JSON.parse(estructurasFijasMultiplesStr)
          if (Array.isArray(estructurasFijasMultiples)) {
            estructurasFijasMultiples.forEach((ef: any) => {
              // CRÍTICO: NO agregar id_estructura si es 0
              // Solo agregar id_receta (identificador principal) y id (ID del registro)
              if (ef.id_receta) {
                idsEstructurasSeleccionadas.add(ef.id_receta?.toString())
              }
              if (ef.id && ef.id !== 0) {
                idsEstructurasSeleccionadas.add(ef.id?.toString())
              }
            })
          }
        }
      } catch (e) {
      }
      
      // Filtrar recetaEstructuraFijas INCLUYENDO SOLO las que fueron seleccionadas
      if (idsEstructurasSeleccionadas.size > 0 && recetaEstructuraFijas.length > 0) {
        // Solo mostrar logs si hay datos relevantes para procesar
        const filtradas = recetaEstructuraFijas.filter((rec: any) => {
          // Obtener rec_codigo de la receta (value corresponde a rec_codigo)
          const recCodigo = rec.value ? rec.value.toString() : (rec.rec_codigo ? rec.rec_codigo.toString() : null)
          
          // Obtener id_receta si existe
          const idReceta = rec.id_receta ? rec.id_receta.toString() : null
          
          // Obtener TODOS los IDs posibles (excluyendo 0 y null)
          const idsPosiblesFija = [
            idReceta, // id_receta si existe
            recCodigo, // rec_codigo (value) - CRÍTICO: Este es el campo principal
            rec.id?.toString() // id del registro (si existe y no es 0)
          ].filter((id: any) => id && id !== 'undefined' && id !== 'null' && id !== '0')
          
          // INCLUIR si alguno de los IDs posibles está en los seleccionados
          return idsPosiblesFija.some((id: string) => idsEstructurasSeleccionadas.has(id))
        })
        
        return filtradas
      } else {
        // Si NO hay estructuras fijas seleccionadas o no hay recetas para filtrar, NO mostrar ninguna
        return []
      }
    } catch (e) {
      // Si hay error, no mostrar nada
      return []
    }
  }, [recetaEstructuraFijas, editContract])

  return (
    <div>
      <Loading open={load} />
      <div>
        <div
          ref={stepperRef}
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
        >
          <div className='card-body row-2 pt-1 menu-horizontal'>
            <div className='stepper-nav'>
              <HorizontalMenuForm menus={menus} />
            </div>
          </div>
          {isReady && (
            <div className=' flex-row-fluid row-2 flex-center container-form1'>
              <Formik
                validationSchema={contractSchemas}
                initialValues={initValues}
                onSubmit={submitStep}
              >
                {(formikProps) => (
                  <Form
                    autoComplete='off'
                    className='mx-auto mw-1200px w-100 pt-7 pb-10 px-10'
                    id='kt_create_account_form'
                  >
                    <div className='current ' data-kt-stepper-element='content'>
                      <StepContract1
                        formikProps={formikProps}
                        getDataEdit={getDataEdit}
                        setIsHomologada={setIsHomologada}
                        title='Contrato'
                        subTitle=''
                        data={{
                          sitios,
                          regimens,
                          usuariosSistios,
                          tipoPlatos,
                          contractList,
                        }}
                        editData={editDataStep1}
                        isReady={isReady}
                        setLoad={setLoad}
                        bloqueado={bloqueado}
                      />
                    </div>
                    <div data-kt-stepper-element='content'>
                      {isHomologada || bloqueado ? (
                        <StepLoadContract2
                          formikProps={formikProps}
                          bloqueado={bloqueado}
                          title='Agregar Estructura'
                          plantilla={_state.plantilla}
                          reloadGrid={reloadGrid}
                          reloadStep2={reloadStep2}
                          subTitle=''
                          data={{
                            alergenos,
                            grupoEstructuras,
                            intolerancias,
                            categoriaDietetica,
                            categoriaDieteticaRec,
                            tipoPlatos,
                          }}
                          isReady={isReady}
                          setLoad={setLoad}
                        />
                      ) : (
                        <StepContract2
                          formikProps={formikProps}
                          title={_state.plantilla > 0 ? 'Editar estructura' : 'Agregar estructura'}
                          reloadGrid={reloadGrid}
                          reloadStep2={reloadStep2}
                          subTitle=''
                          data={{
                            alergenos,
                            grupoEstructuras,
                            intolerancias,
                            categoriaDietetica,
                            categoriaDieteticaRec,
                            tipoPlatos,
                          }}
                          isReady={isReady}
                          setLoad={setLoad}
                          estate={_state}
                        />
                      )}
                    </div>
                    <div data-kt-stepper-element='content'>
                      {isHomologada || bloqueado ? (
                        <StepLoadContract6
                          formikProps={formikProps}
                          title='Agregar Estructura Fija'
                          bloqueado={bloqueado}
                          subTitle=''
                          data={{
                            grupoEstructuras,
                              recetaEstructuraFijas: recetaEstructuraFijas,
                            estructuraFijas,
                          }}
                          isReady={isReady}
                        />
                      ) : (
                        <StepContract6
                          formikProps={formikProps}
                          title='Agregar Estructura Fija'
                          subTitle=''
                          data={{
                            grupoEstructuras,
                              recetaEstructuraFijas: recetaEstructuraFijas,
                            estructuraFijas,
                            // Pasar el servicio desde datosContrato para que esté disponible en modo edición
                            // datosContrato es un array, el primer elemento tiene ser_codigo
                            servicio: datosContrato.length > 0 && datosContrato[0]?.ser_codigo 
                              ? (typeof datosContrato[0].ser_codigo === 'string' 
                                  ? parseInt(datosContrato[0].ser_codigo) 
                                  : datosContrato[0].ser_codigo)
                              : (formikProps?.values?.service?.[0]?.value || null),
                          }}
                          isReady={isReady}
                        />
                        )}
                    </div>
                    <div data-kt-stepper-element='content'>
                      {/* {isHomologada || bloqueado ? (
                        <StepLoadContract3
                          formikProps={formikProps}
                          title='Agregarr Receta Fija'
                          bloqueado={bloqueado}
                          setLoading={setLoad}
                          subTitle=''
                          reload3={reload3}
                          data={{
                            grupoEstructuras,
                            categoriaDieteticaRec,
                            ingAdyacentes,
                          }}
                          isReady={isReady}
                        />
                      ) : ( */}
                        <StepContract3
                          formikProps={formikProps}
                          title={
                            _state.plantilla > 0 ? 'Editarr receta fija' : 'Agregar receta fija'
                          }
                          setLoading={setLoad}
                          subTitle=''
                          reload3={reload3}
                          data={{
                            grupoEstructuras,
                            categoriaDieteticaRec,
                            ingAdyacentes,
                            recetaFija: recetaFijaFiltrada
                          }}
                          isReady={isReady}
                          estate={_state}
                        />
                      {/* )} */}
                    </div>
                    <div data-kt-stepper-element='content'>
                      {isHomologada || bloqueado ? (
                        <StepLoadContract4
                          formikProps={formikProps}
                          bloqueado={bloqueado}
                          title='Agregar Frecuencia Ingredientes'
                          subTitle=''
                          data={{
                            grupoEstructuras,
                            categoriaDieteticaRec,
                            ingAdyacentes,
                          }}
                          isReady={isReady}
                          reload4={reload4}
                        />
                      ) : (
                        <StepContract4
                          formikProps={formikProps}
                          title={
                            _state.plantilla > 0
                              ? 'Editar Frecuencia Ingredientes'
                              : 'Agregar Frecuencia Ingredientes'
                          }
                          subTitle=''
                          data={{
                            grupoEstructuras,
                            categoriaDieteticaRec,
                            ingAdyacentes,
                          }}
                          isReady={isReady}
                          reload4={reload4}
                          estate={_state}
                        />
                      )}
                    </div>

                    <div data-kt-stepper-element='content'>
                      <StepContract5
                        formikProps={formikProps}
                        title='Ingreso de reglas'
                        subTitle=''
                        reload={reload5}
                        data={{
                          sitios,
                          regimens,
                        }}
                        setLoad={setLoad}
                      />
                    </div>
                    <div className='d-flex flex-end'>
                      <div className='mr-2'>
                        <button
                          onClick={prevStep}
                          type='button'
                          className='btn btn-lg btn-danger me-3'
                          data-kt-stepper-action='previous'
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr063.svg'
                            className='svg-icon-4 me-1'
                          />
                          Volver
                        </button>
                      </div>

                      <div>
                        {/* { */}
                        {/* !(hasContract?.plantilla > 0 && stepper?.current?.currentStepIndex === 6) && */}
                        <button
                          type='submit'
                          className='btn btn-lg btn-primary me-3'
                          onClick={() => {}}
                        >
                          <span className='indicator-label'>
                            {!isSubmitButton && 'Continuar'}
                            {isSubmitButton && 'Enviar'}
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr064.svg'
                              className='svg-icon-3 ms-2 me-0'
                            />
                          </span>
                        </button>
                        {/* } */}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
export {CreateContract}



